// src/constants/translations.js
export const translations = {
  en: {
    // Common
    common: {
      loading: 'Loading...',
      save: 'Save',
      print: 'Print',
      cancel: 'Cancel',
      delete: 'Delete',
      deleting: 'Deleting…',
      edit: 'Edit',
      add: 'Add',
      create: 'Create',
      update: 'Update',
      search: 'Search...',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      apply: 'Apply',
      reset: 'Reset',
      clear: 'Clear',
      select: 'Select',
      all: 'All',
      none: 'None',
      actions: 'Actions',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      price: 'Price',
      quantity: 'Quantity',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Tax',
      discount: 'Discount',
      amount: 'Amount',
      date: 'Date',
      time: 'Time',
      type: 'Type',
      category: 'Category',
      image: 'Image',
      settings: 'Settings',
      profile: 'Profile',
      logout: 'Sign Out',
      signOut: 'Sign Out',
      myProfile: 'My Profile',
      notifications: 'Notifications',
      noData: 'No data available',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Info',
      required: 'Required',
      optional: 'Optional',
      active: 'Active',
      inactive: 'Inactive',
      enabled: 'Enabled',
      disabled: 'Disabled',
      online: 'Online',
      offline: 'Offline',
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      minutesAgo: 'minutes ago',
      locale: 'en-US',
      owner: 'Owner',
      due: 'Due',
      swipe: 'Swipe',
      pullToRefresh: 'Pull to refresh',
      refreshing: 'Refreshing...',
      hide: 'Hide',
      view: 'View',
      remove: 'Remove',
      note: 'Note',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      processing: 'Processing...',
      printing: 'Printing…',
      justAMoment: 'Just a moment...',
    },
    
    // Auth
    auth: {
      welcomeBack: 'Welcome Back',
      signInToAccount: 'Sign in to your account',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      signUp: 'Sign Up',
      signingUp: 'Signing up...',
      createAccount: 'Create Your Account',
      creatingAccount: 'Creating Account...',
      signupPageTitle: 'Create Account',
      signupSubtitle: 'Get started with your free restaurant workspace.',
      signupKicker: 'THE RESTAURANT STANDARD',
      signupHeadline: 'Operations built for clarity.',
      signupBody:
        'POS, floor, menu, and reporting in one workspace—so your team spends less time on tools and more time on guests.',
      signupTrustedBy: 'TRUSTED BY TEAMS WORLDWIDE',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
      confirmPassword: 'Confirm Password',
      forgotPassword: "Forgot your password?",
      resetPassword: 'Reset Password',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      firstName: 'First Name',
      lastName: 'Last Name',
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Doe',
      signupEmailPlaceholder: 'john@company.com',
      signupPasswordPlaceholder: '........',
      signupConfirmPasswordPlaceholder: '........',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      phone: 'Phone',
      emailRequired: 'Email is required',
      emailAddress: 'Email Address',
      passwordRequired: 'Password is required',
      emailInvalid: 'Please enter a valid email',
      passwordTooShort: 'Password must be at least 6 characters',
      passwordMinLength: 'Password must be at least 8 characters',
      passwordsDoNotMatch: 'Passwords do not match',
      loginSuccess: 'Login successful',
      loginError: 'Login failed. Please check your credentials.',
      registerSuccess: 'Registration successful',
      registerError: 'Registration failed. Please try again.',
      resetPasswordInstructions: 'Enter your email address and we\'ll send you a link to reset your password.',
      resetPasswordSent: 'If an account exists with the email address you provided, we have sent password reset instructions to that address.',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      returnToSignIn: 'Return to Sign In',
      backToSignIn: 'Back to Sign In',
      verifyTitle: 'Verify your email',
      verifySubtitle: 'Enter the 6-digit code we sent to',
      verifyCodeLabel: 'Verification code',
      verifyButton: 'Verify & continue',
      verifying: 'Verifying...',
      verifyInvalidFormat: 'Enter the 6-digit code from your email.',
      verifyFailed: 'Verification failed. Please try again.',
      verifyNoCode: "Didn't get the code?",
      verifyResend: 'Resend code',
      verifyResendIn: 'Resend in {{seconds}}s',
      verifyResent: 'A new code has been sent.',
      verifyResendFailed: 'Could not resend the code. Please try again.',
      createNewPassword: 'Create New Password',
      newPassword: 'New Password',
      newPasswordRequired: 'New password is required',
      confirmNewPassword: 'Confirm New Password',
      passwordResetSuccess: 'Your password has been reset successfully.',
      enterNewPassword: 'Enter and confirm your new password below.',
      resetting: 'Resetting...',
      signInWithNewPassword: 'Sign In with your new password',
    },

    // Navigation
    nav: {
      dashboard: 'Dashboard',
      manageRestaurant: 'Manage Restaurant',
      branches: 'Branches',
      staff: 'Staff',
      posSystem: 'POS System',
      qrMenu: 'QR Menu',
      branchMenus: 'Branch Menus',
      branchTables: 'Branch Tables',
      colorThemes: 'Color Themes',
      main: 'Main',
      branchAccess: 'Branch Access',
      restaurantPro: 'RestaurantPro',
      ordersHistory: 'Orders History',
      myOrders: 'My Orders',
      expenses: 'Expenses',
      invoices: 'Invoices',
      downloads: 'Downloads',
      adminPortal: 'Admin Portal',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      welcomeBack: 'Welcome back',
      overview: 'Overview',
      overviewText: "Here's an overview of your restaurant management system",
      statistics: 'Statistics',
      recentActivity: 'Recent Activity',
      quickActions: 'Quick Actions',
      totalSales: 'Total Sales',
      totalOrders: 'Total Orders',
      totalCustomers: 'Total Customers',
      totalRevenue: 'Total Revenue',
      todaySales: "Today's Sales",
      todayOrders: "Today's Orders",
      monthlyRevenue: 'Monthly Revenue',
      weeklyRevenue: 'Weekly Revenue',
      topSellingItems: 'Top Selling Items',
      lowStockItems: 'Low Stock Items',
      managerDashboard: 'Manager Dashboard',
      managerSubtitle: 'Manage menus, tables, staff, and orders',
      waiterDashboard: 'Waiter Dashboard',
      waiterSubtitle: 'Manage active orders and tables',
      activeMenuItems: 'Active Menu Items',
      staffMembers: 'Staff Members',
      ordersToday: 'Orders Today',
      todayRevenue: "Today's Revenue",
      activeOrders: 'Active Orders',
      occupiedTables: 'Occupied Tables',
      ordersReady: 'Orders Ready',
      avgWaitingTime: 'Avg. Waiting Time',
      underDevelopment: 'Under Development',
      underDevelopmentText: 'dashboard is currently under development.',
      electronHubBadge: 'Resto360 Desktop',
      electronHubSubtitle: 'Counter control hub — open POS, review today, and manage remote printing from this PC.',
      electronOpenPos: 'Open Point of Sale',
      electronOpenPosHint: 'Tables, orders, and kitchen printing',
      electronOrdersHistory: 'Orders history',
      electronOrdersHistoryHint: 'Review completed and active orders',
      electronPrintStationTitle: 'Kitchen print station',
      electronPrintStationHint: 'Enable Print station in POS → Settings on this counter so web and QR orders print here.',
      electronTodayAtBranch: 'Today at your branch',
      restaurants: 'Restaurants',
      branches: 'Branches',
      employees: 'Employees',
      tables: 'Tables',
      addRestaurant: 'Add Restaurant',
      viewAll: 'View All',
      noRestaurants: 'No restaurants yet',
      noBranches: 'No branches yet',
      noRecentActivity: 'No recent activity',
      noPendingTasks: 'No pending tasks',
      pendingTasks: 'Pending Tasks',
      onboardingTasks: 'Getting Started',
      onboardingProgress: '{{completed}} of {{total}} complete',
      onboardingAllDone: "You're all set! Your restaurant is ready to go.",
      onboarding: {
        addRestaurantTitle: 'Create your restaurant',
        addRestaurantDetails: 'Add your restaurant name, location, and contact details.',
        addBranchTitle: 'Add your first branch',
        addBranchDetails: 'Set up a location where you serve customers.',
        setupMenuTitle: 'Build your menu',
        setupMenuDetails: 'Add dishes, prices, and categories so staff can take orders.',
        addTablesTitle: 'Set up tables',
        addTablesDetails: 'Configure dine-in tables for the POS floor plan.',
        inviteStaffTitle: 'Invite your team',
        inviteStaffDetails: 'Add managers, waiters, or kitchen staff to your branches.',
        setupQrMenuTitle: 'Publish a QR menu',
        setupQrMenuDetails: 'Let guests scan, browse, and order from their phones.',
      },
      systemStatus: 'System Status',
      quickAccess: 'Quick Access',
      recentTabs: 'Recent',
      noRecentTabs: 'Pages you visit will appear here for quick access.',
      page: 'Page',
      activeSessions: 'Active Sessions',
      lastBackup: 'Last Backup',
      hoursAgo: 'hours ago',
      reviewInventoryReport: 'Review inventory report',
      monthlyInventoryCheck: 'Monthly inventory check for Downtown Branch',
      approveStaffSchedule: 'Approve staff schedule',
      weeklyScheduleApproval: 'Weekly schedule for Mall Branch needs approval',
      updateMenuPrices: 'Update menu prices',
      seasonalPriceAdjustments: 'Seasonal price adjustments for all branches',
      reviewPromotionResults: 'Review promotion results',
      checkWeekendOffers: 'Check performance of weekend special offers',
      largeOrderReceived: 'Large Order Received',
      downtownBranchCatering: 'Downtown Branch: Catering order for 50 people ($1,250)',
      menuUpdated: 'Menu Updated',
      newSeasonalItems: 'Mall Branch: 8 new seasonal items added to menu',
      staffScheduleUpdated: 'Staff Schedule Updated',
      weekendShiftsUpdated: 'All Branches: Weekend shifts updated for 24 employees',
      newPromotionCreated: 'New Promotion Created',
      familyWeekendSpecial: 'All Branches: "Family Weekend" special 20% discount',
      equipmentMaintenance: 'Equipment Maintenance',
      kitchenEquipmentServicing: 'Downtown Branch: Kitchen equipment servicing completed',
      ownerDashboard: 'Owner Dashboard',
      ownerSubtitle: "Here's an overview of your restaurant management system",
      totalRestaurants: 'Total Restaurants',
      totalBranches: 'Total Branches',
      totalEmployees: 'Total Employees',
      totalTables: 'Total Tables',
      tasksRequiringAttention: 'Tasks Requiring Attention',
      viewAllTasks: 'View all tasks',
      yourRestaurants: 'Your Restaurants',
      viewAllRestaurants: 'View all restaurants',
      noRestaurantsAdded: "You haven't added any restaurants yet.",
      viewAllNotifications: 'View all notifications',
      loadingDashboard: 'Loading your dashboard...',
      revenue: 'Revenue',
      processOrders: 'Process orders',
      manageLocations: 'Manage locations',
      updateOfferings: 'Update offerings',
      manageTeam: 'Manage team',
      tableManagement: 'Table management',
      reports: 'Reports',
      viewAnalytics: 'View analytics',
    },

    // Restaurant
    restaurant: {
      title: 'Restaurant',
      restaurants: 'Restaurants',
      manageRestaurant: 'Manage Restaurant',
      restaurantName: 'Restaurant Name',
      restaurantDescription: 'Restaurant Description',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      createRestaurant: 'Create Restaurant',
      editRestaurant: 'Edit Restaurant',
      updateRestaurant: 'Update Restaurant',
      deleteRestaurant: 'Delete Restaurant',
      restaurantDetails: 'Restaurant Details',
      restaurantAnalytics: 'Restaurant Analytics',
      noRestaurants: 'No restaurants found',
      addRestaurant: 'Add Restaurant',
      addNewRestaurant: 'Add New Restaurant',
      loadingRestaurant: 'Please wait while we load your restaurant information.',
      loadingRestaurantInfo: 'Loading restaurant information...',
      selectRestaurant: 'Select a Restaurant',
      selectRestaurantMessage: 'Please select a restaurant from the dropdown in the top navigation bar to manage its details. Once selected, you\'ll be automatically redirected to the restaurant management page.',
      noRestaurantsMessage: 'You don\'t have any restaurants yet. Please create a restaurant first to access the restaurant management features.',
      restaurantLogo: 'Restaurant Logo',
      restaurantLogoRequired: 'Restaurant Logo',
      uploadLogo: 'Upload Logo',
      replaceLogo: 'Replace Logo',
      logoDescription: 'Upload a logo to use in QR menu templates',
      noLogoUploaded: 'No logo uploaded. Upload a logo to use in QR menu templates.',
      cuisineType: 'Cuisine Type',
      selectCuisine: 'Select a cuisine',
      phoneNumber: 'Phone Number',
      emailAddress: 'Email Address',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      description: 'Description',
      descriptionOptional: 'Description (Optional)',
      clickToUploadLogo: 'Click to upload a logo',
      logoFormatsHint: 'JPEG, PNG, GIF, SVG, max 2MB',
      logoRequired: 'Restaurant logo is required',
      enterRestaurantName: 'Enter restaurant name',
      enterPhoneNumber: 'Enter phone number (e.g., +1-555-123-4567)',
      enterEmailAddress: 'Enter email address',
      enterAddress: 'Enter street address',
      addRestaurantSubtitle: 'Set up your restaurant profile with basic details, contact info, and location.',
      editRestaurantSubtitle: 'Update your restaurant profile, contact details, and location information.',
      requiredFieldsNote: 'Fields marked with * are required. All other fields are optional but help complete your profile.',
      backToRestaurant: 'Back to Restaurant',
      backToRestaurants: 'Back to Restaurants',
      emailDomainHint: 'Suggested domain based on restaurant name:',
      emailDomainClear: 'Click to remove and type a custom email',
      emailLocalPlaceholder: 'e.g. admin, info, contact',
      failedToLoadRestaurant: 'Failed to load restaurant data. Please try again.',
      errorSavingRestaurant: 'Error saving restaurant. Please try again.',
      saving: 'Saving...',
      cancel: 'Cancel',
      nameRequired: 'Restaurant name is required',
      phoneRequired: 'Phone number is required',
      emailRequired: 'Email address is required',
      staffEmailDomain: 'Staff Email Domain',
      staffEmailDomainHint: 'Staff logins will use this domain — e.g. manager@yourdomain.com. Choose a suggestion or type your own.',
      findingDomains: 'Finding available domains…',
      domainPlaceholder: 'e.g. yourrestaurant.com',
      domainRequired: 'Please choose an email domain',
      phoneInvalid: 'Phone number must be between 10-15 digits',
      phoneFormat: 'Please enter a valid phone number',
      emailInvalid: 'Please enter a valid email address',
      logoInvalid: 'Please upload a valid image (JPEG, PNG, GIF, SVG)',
      logoTooLarge: 'Logo must be less than 2MB',
      location: 'Location',
      contactInformation: 'Contact Information',
      branchesWithCount: 'Branches ({{count}})',
      statLabelBranches: 'Branches',
      statLabelEmployees: 'Employees',
      statLabelMenuItems: 'Menu Items',
      statLabelTotalTables: 'Total Tables',
      branchManagement: 'Branch Management',
      branchManagementDesc: 'Add and manage restaurant branches with detailed configurations',
      menuManagementDesc: 'Create and edit menu items with categories and pricing',
      staffManagement: 'Staff Management',
      staffManagementDesc: 'Manage restaurant staff, roles, and permissions',
      analyticsReports: 'Analytics & Reports',
      analyticsReportsDesc: 'View detailed analytics and generate business reports',
      noBranchesAdded: 'No branches have been added yet.',
      addFirstBranch: 'Add First Branch',
      manageAllBranches: 'Manage All Branches',
      management: 'Management',
      sectionBranches: 'Branches',
      aboutRestaurant: 'About {{name}}',
      analyticsBackToRestaurants: 'Back to Restaurants',
      analyticsLoading: 'Loading restaurant analytics...',
      analyticsNoDataTitle: 'No Analytics Data Available',
      analyticsNoDataDescription:
        "This restaurant doesn't have any analytics data yet. Analytics will appear once branches start generating data.",
      analyticsTryAgain: 'Try Again',
      analyticsDashboardTitle: '{{name}} - Analytics Dashboard',
      analyticsRefreshing: 'Refreshing...',
      analyticsRefresh: 'Refresh',
      analyticsTimeRange: 'Time Range',
      analyticsLast7Days: 'Last 7 Days',
      analyticsLast30Days: 'Last 30 Days',
      analyticsLast90Days: 'Last 90 Days',
      analyticsLastYear: 'Last Year',
      analyticsBranchFilter: 'Branch Filter',
      analyticsAllBranches: 'All Branches',
      analyticsTotalBranchesCount: 'Total Branches: {{count}}',
      analyticsSummary: 'Analytics Summary',
      analytics7Days: '7 Days',
      analytics30Days: '30 Days',
      analytics90Days: '90 Days',
      analytics1Year: '1 Year',
      analyticsTimePeriod: 'Time Period',
      analyticsDataPoints: 'Data Points',
      analyticsLastUpdated: 'Last Updated',
      analyticsCombinedFromAllBranches: 'Combined from all branches',
      analyticsTotalOrders: 'Total Orders',
      analyticsAllBranchesCombined: 'All branches combined',
      analyticsTotalExpenses: 'Total Expenses',
      analyticsAllOperationalCosts: 'All operational costs',
      analyticsNetProfit: 'Net Profit',
      analyticsRevenueMinusExpenses: 'Revenue minus expenses',
      analyticsConfiguration: 'Analytics Configuration',
      analyticsBranchSelection: 'Branch Selection',
      analyticsAllBranchesCombinedLabel: 'All Branches Combined',
      analyticsSalesTrendAllBranches: 'Sales Trend (All Branches)',
      analyticsNoSalesData: 'No sales data available',
      analyticsDailyOrdersAllBranches: 'Daily Orders (All Branches)',
      analyticsNoOrdersData: 'No orders data available',
      analyticsRevenueVsExpensesAllBranches: 'Revenue vs Expenses (All Branches)',
      analyticsNoFinancialData: 'No financial data available',
      analyticsTopPerformingItems: 'Top Performing Items (All Branches)',
      analyticsOrders: 'Orders',
      analyticsQty: 'Qty',
      analyticsBestPerformingBranch: 'Best Performing Branch',
      analyticsLoadingBestBranch: 'Loading best performing branch...',
      analyticsBestPerformingBranchBadge: '🏆 Best Performing Branch',
      analyticsAvgOrderValue: 'Avg Order Value',
      analyticsGrowthRate: 'Growth Rate',
      analyticsBranchPerformanceRankings: 'Branch Performance Rankings',
      analyticsTopPerformer: '🏆 TOP PERFORMER',
      analyticsRank: 'Rank {{rank}}',
      analyticsAvgOrder: 'Avg Order',
      analyticsGrowth: 'Growth',
      analyticsNoBestBranchData: 'No best performing branch data available for this time range.',
      analyticsDailyReports: 'Daily Reports',
      analyticsDaysAvailableInDatabase: '{{count}} Days Available in Database',
      analyticsViewByRange: '{{range}} Analytics View',
      analyticsLoadingDates: 'Loading Dates...',
      analyticsFilterDates: 'Filter Dates:',
      analyticsAllAvailableDates: 'All Available Dates',
      analyticsShowingTotalDates: 'Showing {{count}} total dates from database',
      analyticsLoadingAllDates: 'Loading all available dates from database...',
      analyticsNoSalesDataShort: 'No Sales Data',
      analyticsGenerating: 'Generating...',
      analyticsGenerateReport: 'Generate Report',
      analyticsNoDatesAvailable: 'No Dates Available',
      analyticsNoDatesDescription:
        'No dates with data found in the database. Reports will appear here once orders and expenses are recorded.',
      analyticsNoDataToDownload: 'No data available to download',
      analyticsPdfAutotableMissing:
        'PDF generation failed: autoTable plugin not loaded. Please refresh the page and try again.',
      analyticsPdfTitle: 'RESTAURANT DAILY FINANCIAL REPORT',
      analyticsGeneratedOn: 'Generated on',
      analyticsRestaurantInformation: 'Restaurant Information',
      analyticsRestaurantId: 'Restaurant ID',
      analyticsRestaurantName: 'Restaurant Name',
      analyticsReportType: 'Report Type',
      analyticsDailyFinancialAnalysis: 'Daily Financial Analysis (Combined from All Branches)',
      analyticsFinancialSummaryAllBranches: 'Financial Summary (All Branches Combined)',
      analyticsMetric: 'Metric',
      analyticsValue: 'Value',
      analyticsDailyRevenue: 'Daily Revenue',
      analyticsDailyExpenses: 'Daily Expenses',
      analyticsOrdersProcessed: 'Orders Processed',
      analyticsProfitMargin: 'Profit Margin',
      analyticsAverageOrderValue: 'Average Order Value',
      analyticsBranchBreakdown: 'Branch Breakdown',
      analyticsSales: 'Sales',
      analyticsExpenses: 'Expenses',
      analyticsProfit: 'Profit',
      analyticsUnknownBranch: 'Unknown Branch',
      analyticsPdfFooter: 'Restaurant Management System - Daily Financial Report',
      analyticsPdfSuccess: 'Daily PDF report generated successfully!',
      analyticsPdfError: 'Error generating daily PDF report: {{error}}. Please try again.',
      analyticsNoBranchesFound: 'No branches found',
      analyticsUnavailable: 'Analytics unavailable',
    },

    // Branch
    branch: {
      title: 'Branch',
      branches: 'Branches',
      branchName: 'Branch Name',
      branchDescription: 'Branch Description',
      createBranch: 'Create Branch',
      editBranch: 'Edit Branch',
      deleteBranch: 'Delete Branch',
      branchDetails: 'Branch Details',
      branchSettings: 'Branch Settings',
      branchAnalytics: 'Branch Analytics',
      noBranches: 'No branches found',
      addBranch: 'Add Branch',
      selectBranch: 'Select Branch',
      branchList: 'Branch List',
      globalBranchList: 'Global Branch List',
      assignedMenus: 'Assigned Menus',
      assignedTables: 'Assigned Tables',
      sectionManager: 'Section Manager',
      offlineSettings: 'Offline Settings',
      offlineModeSettings: 'Offline Mode Settings',
      offlineAutoSaveSettings: 'Offline Auto Save Settings',
      paymentFirstSettings: 'Payment First Settings',
      receiptScanningSettings: 'Receipt Scanning Settings',
      currency: 'Currency',
      branchLogo: 'Branch Logo',
      uploadLogo: 'Upload Logo',
      replaceLogo: 'Replace Logo',
      logoDescription: 'Upload a logo to use in QR menu templates (falls back to restaurant logo if not set)',
      noLogoUploaded: 'No logo uploaded. Upload a logo to use in QR menu templates (falls back to restaurant logo if not set).',
      searchBranchesPlaceholder: 'Search branches by name, address, or city...',
      allBranches: 'All Branches',
      activeOnly: 'Active Only',
      inactiveOnly: 'Inactive Only',
      tablesCount: '{{count}} Tables',
      menuItemsCount: '{{count}} Menu items',
      branchLocationsCount: 'Branch Locations ({{count}})',
      loadingBranches: 'Loading branches...',
      getStartedAddFirstBranch: 'Get started by adding your first branch for {{name}}',
      noBranchesMatchFilter: 'No branches match your current search or filter criteria',
      selectRestaurantToViewBranches: 'Please select a restaurant from the dropdown in the top navigation bar to view its branches.',
      loadingRestaurantInformation: 'Loading Restaurant Information...',
    },

    // Sales Report
    salesReport: {
      title: 'Sales Report',
      summary: 'Sales Summary',
      menuItems: 'Menu Items Sales',
      totalSales: 'Total Sales',
      totalExpenses: 'Total Expenses',
      netProfit: 'Net Profit',
      avgOrderValue: 'Average Order Value',
      orders: 'orders',
      margin: 'margin',
      cash: 'Cash',
      card: 'Card',
      mobile: 'Mobile',
      qr: 'QR Code',
      paymentMethods: 'Payment Methods Distribution',
      dailySalesTrend: 'Daily Sales Trend',
      dailySalesSubtitle: '{{count}} days in selected period',
      avgDailySales: 'Avg daily',
      bestDay: 'Best day',
      periodTrend: 'Period trend',
      salesByHour: 'Sales by Hour',
      ordersByHour: 'Orders by Hour',
      peakHourSales: 'Peak Hour (Sales)',
      peakHourOrders: 'Peak Hour (Orders)',
      busiestTimes: 'Busiest Times',
      busiestTimesSalesHint: 'Top hours by revenue for the selected period',
      busiestTimesOrdersHint: 'Top hours by order volume for the selected period',
      peakShare: '{{pct}}% of peak',
      salesTrend: 'Sales & Items Trend',
      topItems: 'Top 10 Selling Items',
      itemName: 'Item Name',
      quantity: 'Quantity',
      percentage: '% of Total',
      printThermal: 'Print report (receipt printer)',
      printThermalHint: 'Uses the same counter receipt printer as POS',
      printTitle: 'SALES REPORT',
      printPeriod: 'Period',
      printedAt: 'Printed',
      printSales: 'SALES',
      printCardNote: 'Card incl. mobile & QR',
      printTotalDiscount: 'Total discount',
      printExpenses: 'EXPENSES',
      printOrders: 'ORDERS',
      printOrderCount: 'No. of orders',
      printTakeaways: 'Takeaways',
      printTableOrders: 'Table orders',
      printDelivery: 'Delivery',
      printByCategory: 'BY CATEGORY',
      printNoCategories: 'No category data',
      printDeleted: 'DELETED ORDERS',
      printDeletedCount: 'Count',
      printDeletedValue: 'Total value',
      printFooter: 'End of report',
    },

    // Menu
    menu: {
      title: 'Menu',
      menuItems: 'Menu Items',
      menuItem: 'Menu Item',
      itemName: 'Item Name',
      itemDescription: 'Branch menu items can be customized with different prices and descriptions. Create and manage restaurant-wide menu items here. Branches can customize these items.',
      itemPrice: 'Item Price',
      itemCategory: 'Item Category',
      itemImage: 'Item Image',
      createMenuItem: 'Create Menu Item',
      editMenuItem: 'Edit Menu Item',
      deleteMenuItem: 'Delete Menu Item',
      noMenuItems: 'No menu items found',
      addMenuItem: 'Add Menu Item',
      categories: 'Categories',
      categoryName: 'Category Name',
      createCategory: 'Create Category',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      importMenu: 'Import Menu from Restaurant',
      exportMenu: 'Export Menu',
      menuFilters: 'Menu Filters',
      searchMenu: 'Search Menu',
      noItemsMessage: 'No items found',
      menuManagement: 'Menu Management',
      backToBranch: 'Back to Branch',
      backToRestaurant: 'Back to Restaurant',
      noCategoriesAvailable: 'No categories available',
      loadingMenuItems: 'Loading menu items...',
      noMenuItemsFound: 'No menu items found matching your search.',
      noMenuItemsForBranch: 'No menu items available for this branch.',
      noMenuItemsInCategory: 'No menu items available in this category.',
      addMenu: 'Add Menu',
      createBranchItem: 'Create Branch Item',
      copyFromBranch: 'Copy from Branch',
      captureMenu: 'Capture Menu',
      dragDropTipsTitle: 'Drag & drop tips:',
      dragDropTipsBody: 'drag menu item cards onto the Counter Items panel below to route them to the counter printer. Click Edit categories above to merge duplicate categories via drag & drop.',
      clearFilters: 'Clear filters',
      filterByCategory: 'Filter by category',
      editCategories: 'Edit categories',
      doneEditing: 'Done editing',
      itemsCount: '{{count}} items',
      itemsCountSingle: '{{count}} item',
      itemsCountFiltered: '{{filtered}} of {{total}}',
      noItemsMatchingSearch: 'No menu items found matching "{{query}}"',
      tryDifferentKeywords: 'Try using different keywords or clear the search',
      clearSearch: 'Clear Search',
      noItemsInBranch: 'No menu items found in this branch',
      importToGetStarted: 'Import menu items from the restaurant menu to get started',
      createFirstItem: 'Create your first menu item to get started',
      searchPlaceholder: 'Search menu items by name, description, or category...',
      searchAriaLabel: 'Search menu items',
      importing: 'Importing...',
      loadingCategories: 'Loading categories...',
      deals: 'Deals',
      exclusiveOffers: 'Exclusive Offers',
      copying: 'Copying...',
    },

    // Tables
    table: {
      title: 'Tables',
      tables: 'Tables',
      tableName: 'Table Name',
      tableNumber: 'Table Number',
      tableCapacity: 'seats',
      tableStatus: 'Table Status',
      createTable: 'Create Table',
      editTable: 'Edit Table',
      deleteTable: 'Delete Table',
      tableDetails: 'Table Details',
      tableManagement: 'Advanced Table Management',
      tableFormation: 'Table Formation',
      tableFormationDescription: 'Use Table Formation to organize tables by sections, manage table layouts, and configure seating arrangements.',
      tableSetupConfig: 'Table Setup Config',
      noTables: 'No Tables Found',
      addTable: 'Add Table',
      available: 'Available',
      occupied: 'Occupied',
      reserved: 'Reserved',
      cleaning: 'Cleaning',
      goToFormation: 'Go to Formation',
      seats: 'Seats',
      searchTables: 'Search tables...',
      allWithCount: 'All ({{count}})',
      availableWithCount: 'Available ({{count}})',
      occupiedWithCount: 'Occupied ({{count}})',
      tableWithNumber: 'Table {{number}}',
    },

    // POS
    pos: {
      messageOrder: 'Message order',
      messageOrderPlaceholder: '2 chicken biryani\nkola x3\ncheese naan\n1 ayran',
      messageOrderHint: 'Type the order like a note — one item per line or separated by commas. Quantity before or after the name; no quantity means 1.',
      messageOrderParsing: 'Reading…',
      messageOrderParse: 'Read order',
      messageOrderDone: 'Done',
      messageOrderSomeNotAdded: 'Some items could not be added:',
      messageOrderAddToCart: 'Add to cart',
      messageOrderNotFound: 'not found in menu, add manually',
      messageOrderNothingFound: 'No order items were recognized — please check the note.',
      messageOrderNothingMatched: 'Nothing matched the menu — go back and edit the note.',
      proceedToMenu: 'Proceed to Menu',
      specialInstructions: 'Special Instructions',
      specialInstructionsPlaceholder: 'Any special requests for the order...',
      area: 'Area',
      streetAddress: 'Street Address',
      city: 'City',
      building: 'Building',
      floor: 'Floor',
      apartment: 'Apartment',
      landmark: 'Landmark',
      label: 'Label',
      title: 'POS System',
      pointOfSale: 'Point of Sale',
      newOrder: 'New Order',
      currentOrder: 'Current Order',
      orderHistory: 'Order History',
      checkout: 'Checkout',
      payment: 'Payment',
      cash: 'Cash',
      card: 'Card',
      other: 'Other',
      customerInfo: 'Customer Info',
      customerName: 'Guest',
      customerPhone: 'Customer Phone',
      customerEmail: 'Customer Email',
      orderItems: 'Order Items',
      orderSummary: 'Order Summary',
      orderTotal: 'Order Total',
      total: 'Total',
      applyDiscount: 'Apply Discount',
      discountAmount: 'Discount Amount',
      discountPercentage: 'Discount Percentage',
      paymentMethod: 'Payment Method',
      paymentStatus: 'Payment Status',
      paid: 'Paid',
      unpaid: 'Unpaid',
      partial: 'Partial',
      orderStatus: 'Order Status',
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      cancelled: 'Cancelled',
      table: 'Table',
      takeaway: 'Takeaway',
      delivery: 'Delivery',
      deliveryInfo: 'Delivery Info',
      dineIn: 'Dine In',
      selectTable: 'Select Table',
      switchTable: 'Switch Table',
      addItem: 'Add Item',
      removeItem: 'Remove Item',
      updateQuantity: 'Update Quantity',
      printReceipt: 'Print Receipt',
      emailReceipt: 'Email Receipt',
      kitchenDisplay: 'Kitchen Display',
      customerDisplay: 'Customer Display',
      expenses: 'Expenses',
      newOrders: 'New Orders',
      notifications: 'Notifications',
      socketConnection: 'Socket Connection',
      connected: 'Connected',
      disconnected: 'Disconnected',
      syncDetails: 'Sync Details',
      voiceRecognition: 'Voice Recognition',
      listening: 'Listening...',
      speakNow: 'Speak now...',
      touchKeyboard: 'Touch Keyboard',
      dailyExpenseManager: 'Daily Expense Manager',
      customerOrderSimulator: 'Customer Order Simulator',
      menuActive: 'Menu is available for POS operations',
      menuActiveHint: 'Customers can order',
      menuInactive: 'Menu is Currently Inactive',
      menuDeactivated: 'The menu has been deactivated and is not available for POS operations.',
      activateMenu: 'Activate Menu',
      selectBranchForVoice: 'Please select a branch first to use voice recognition.',
      voiceNotAvailable: 'Voice recognition not available.',
      modifyOrder: 'Modify Order',
      pleaseClickModifyButton: 'Please click the "Modify" button to add items to this order.',
      orders: 'Orders',
      items: 'Items',
      active: 'Active',
      inactive: 'Inactive',
      searchMenu: 'Search menu...',
      selectTableToStart: 'Select a table to start taking orders',
      editCustomer: 'Edit Customer',
      payAndPlaceOrder: 'Pay & Place Order',
      placeOrder: 'Place Order',
      printRecentBill: 'Print Recent Bill',
      lastOrder: 'Last Order',
      selectItemsFromMenu: 'Select items from the menu to add to this order',
      clickMenuItemsToAdd: 'Click on menu items to add them to the order',
      startByAddingItems: 'Start by adding items from the menu to create an order for this table',
      browseMenu: 'Browse Menu',
      goToMenuTab: 'Go to Menu Tab',
      item: 'Item',
      qty: 'Qty',
      subtotal: 'Subtotal',
      tax: 'Tax',
      discount: 'Discount',
      alerts: 'Alerts',
      receipt: 'RECEIPT',
      kitchenOrder: 'KITCHEN ORDER',
      kitchenNote: 'KITCHEN NOTE:',
      noOrderFound: 'No order found to print receipt',
      noItems: 'No items',
      price: 'Price',
      currentOrder: 'Current Order',
      noItemsInOrder: 'No Items in Order',
      noOrderYet: 'No Order Yet',
      available: 'Available',
      occupied: 'Occupied',
      reserved: 'Reserved',
      allStatus: 'All Status',
      searchTableNumber: 'Search table number...',
      noTablesFound: 'No tables found',
      noTablesFoundMessage: 'Try adjusting your filters or add more tables to your branch',
      allTablesSequential: 'All Tables (Sequential)',
      tables: 'Tables',
      menu: 'Menu',
      myOrders: 'My Orders',
      kds: 'KDS',
      settings: 'Settings',
      selectBranch: 'Select Branch',
      newTakeaway: 'New Takeaway',
      newDelivery: 'New Delivery',
      draft: 'Draft',
      preparing: 'Preparing',
      ready: 'Ready',
      pickedUp: 'Picked Up',
      dispatched: 'Dispatched',
      outForDelivery: 'Out for Delivery',
      delivered: 'Delivered',
      takeawayOrders: 'Takeaway Orders',
      deliveryOrders: 'Delivery Orders',
      searchOrders: 'Search by name, phone, order number...',
      noMatchingOrders: 'No matching active orders',
      noActiveOrders: 'No active orders',
      tryAdjustingFilters: 'Try adjusting your search or filters',
      createFirstOrder: 'Create your first {type} order to get started',
      loadingOrders: 'Loading orders...',
      guest: 'Guest',
      scheduled: 'Scheduled',
      item: 'item',
      items: 'items',
      hasActiveOrders: 'has active orders',
      activeOrders: 'Active Orders',
      useCartPanelToManage: 'Use the cart panel on the right to manage orders',
      noActiveOrdersFound: 'No active orders found',
      paymentFirstTable: 'Payment First - Table',
      checkoutTable: 'Checkout - Table',
      each: 'each',
      modified: 'Modified',
      note: 'Note',
      addDiscount: 'Add discount',
      applySalesTax: 'Apply tax (10%)',
      removeSalesTax: 'Remove tax',
      receiptOrderRef: 'Order #:',
      receiptDate: 'Date:',
      receiptTime: 'Time:',
      receiptItemsHeading: 'ITEMS',
      receiptThankYou: 'Thank you for your visit!',
      receiptItemsToPrepare: 'ITEMS TO PREPARE',
      receiptModificationTitle: 'Running',
      counterOrder: 'COUNTER ORDER',
      receiptAdded: 'ADDED:',
      receiptRemoved: 'REMOVED:',
      receiptQtyChanged: 'QTY CHANGED:',
      receiptNotAvailable: 'N/A',
      receiptVenueFallback: 'RESTAURANT',
      payAndSendToKitchen: 'Pay & Send to Kitchen',
      payNow: 'Pay Now',
      printReceiptFirst: 'Please print the receipt before processing payment',
      statusBilled: 'Billed',
      postPrintModified: 'Modified after bill',
      postPrintPriorityStripe: 'Bill amended after print — review totals',
      selectPaymentMethod: 'Select Payment Method',
      mobilePay: 'Mobile Pay',
      qrCode: 'QR Code',
      splitBill: 'Split Bill',
      splitBillTitle: 'Split Payment',
      splitCashAmount: 'Cash Amount',
      splitCardAmount: 'Card Amount',
      splitRemaining: 'Remaining',
      splitConfirm: 'Confirm Split Payment',
      splitBack: 'Back',
      splitCashExceedsTotal: 'Cash amount cannot exceed total',
      incomingOrders: 'Incoming Orders',
      noPendingOrders: 'No pending orders',
      customer: 'Customer',
      assignToTable: 'Assign to Table',
      pleaseSelectTable: 'Please select a table for this order',
      rejectOrder: 'Reject Order',
      confirmOrder: 'Confirm Order',
      editCustomerInformation: 'Edit Customer Information',
      confirmed: 'Confirmed',
      served: 'Served',
      refresh: 'Refresh',
      kitchenDisplaySystem: 'Kitchen Display System',
      totalOrdersLabel: 'Total Orders',
      servedOrdersCount: 'Served Orders ({{count}})',
      showActiveOrders: 'Show Active Orders',
      allActive: 'All Active',
      noOrdersInKitchen: 'There are currently no orders in the kitchen. New orders will appear here automatically.',
      noOrdersWithFilter: 'No orders with status "{{filter}}". Try changing the filter.',
      startPreparing: 'Start Preparing',
      markReady: 'Mark Ready',
      markServed: 'Mark Served',
      takeawayGuest: 'Takeaway Guest',
      orderNumberLabel: 'Order Number',
      noOrdersToShow: 'No orders to show.',
      searchOrdersHistory: 'Search orders, customers, or items...',
      menuItemHistory: 'Menu Item History',
      export: 'Export',
      history: 'History',
      deletedWas: 'Deleted (was: {{status}})',
      modifiedAndCompleted: 'Modified and Completed',
      viewCart: 'View Cart',
      kitchenReceipt: 'Kitchen Receipt',
      completeModification: 'Complete Modification',
      processPayment: 'Process Payment',
      noActiveSession: 'No Active Session',
      sessionRequiredMessage: 'Session Mode is enabled. You need to start a session before opening a new order.',
      sessionRequiredWaiterMessage: 'Session Mode is enabled. Please ask your branch manager to start a session before taking orders.',
      dismiss: 'Dismiss',
      startSession: 'Start Session',
      startingSession: 'Starting…',
      endSession: 'End Session',
      endDay: 'End Day',
      dayClosed: 'Day Closed',
      tableLayout: 'Table Layout:',
      sequential: 'Sequential',
      sectioned: 'Sectioned',
      cannotEndBusinessDay: 'Cannot End Business Day',
      endDayBlockedMessage: 'Please clear all active orders before ending the business day.',
      occupiedTables: 'Occupied Tables',
      activeTakeawayOrders: 'Active Takeaway / Delivery Orders',
      gotIt: 'Got It',
      unpaidBadge: 'UNPAID — collect at pickup',
      openOrdersWarningTitle: 'Open Orders',
      openOrdersWarningMessage: 'There are still open orders. You can continue anyway — these orders will stay open and can be completed on the next business day (for example, a customer paying later).',
      endSessionAnyway: 'End Session Anyway',
      endDayAnyway: 'End Day Anyway',
      counterOfflineModeTitle: 'Counter is in offline mode',
      counterOfflineModeMessage:
        'The counter POS must be switched to Online mode before orders from this device can reach the kitchen printer. Ask staff at the counter to open Online mode in POS.',
      counterNotConnectedTitle: 'Counter not connected',
      counterNotConnectedMessage:
        'The counter desktop app is not connected. Open Resto360 POS on the counter PC, sign in, and stay in Online mode.',
      counterPrintStationDisabledTitle: 'Kitchen print station off',
      counterPrintStationDisabledMessage:
        'Remote kitchen printing is disabled on the counter. Enable Print station in POS settings on the counter device.',
      remotePrintBlockedTitle: 'Cannot place order',
      remotePrintBlockedMessage: 'Counter print station is not ready for remote orders.',
      floorThemeLight: 'Switch to light tables and menu panel',
      floorThemeDark: 'Switch to dark tables and menu panel',
      floorThemeAria: 'POS tables and menu panel appearance',
    },

    // Customer Display
    customerDisplay: {
      title: 'Order Status',
      subtitle: 'Track your takeaway order status in real-time',
      preparing: 'Preparing',
      ready: 'Ready',
      noOrders: 'No active takeaway orders at the moment',
      customerDetails: 'Customer Details',
      customerName: 'Customer Name',
      enterCustomerName: 'Enter customer name',
      customerNameRequired: 'Customer name is required',
      phoneRequired: 'Phone number is required',
      areaRequiredForDelivery: 'Area is required for delivery',
      streetRequiredForDelivery: 'Street address is required for delivery',
      failedToUpdateCustomerInfo: 'Failed to update customer information. Please try again.',
      deliveryAddress: 'Delivery Address',
      area: 'Area',
      areaRequired: 'Area is required',
      streetAddress: 'Street Address',
      streetRequired: 'Street is required',
      buildingHouse: 'Building/House',
      floor: 'Floor',
      apartmentUnit: 'Apartment/Unit',
      landmark: 'Landmark',
      city: 'City',
      building: 'Building',
      apartment: 'Apartment',
      savedAddresses: 'Saved Addresses',
      addNewAddress: 'Add New Address',
      customerInfoOptionalForTakeaway: 'Customer information is optional for takeaway orders. You can skip these fields.',
      proceedToMenu: 'Proceed to Menu',
      failedToCreateOrder: 'Failed to create order. Please try again.',
      specialInstructions: 'Special Instructions',
    },

    // Orders
    order: {
      title: 'Orders',
      orders: 'Orders',
      orderNumber: 'Order Number',
      orderDate: 'Order Date',
      orderTime: 'Order Time',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      orderTotal: 'Order Total',
      createOrder: 'Create Order',
      editOrder: 'Edit Order',
      deleteOrder: 'Delete Order',
      // Deletion reason (accountability) — staff must say why.
      cannotMovePaidOrder: 'This order is already paid and closed — it cannot be moved to another table.',
      deleteReasonTitle: 'Why are you deleting this order?',
      deleteReasonSubtitle: 'A reason is required. It is saved with the order and visible in History.',
      deleteReasonCustomerCancelled: 'Customer cancelled',
      deleteReasonWrongOrder: 'Wrong order entered',
      deleteReasonDuplicate: 'Duplicate order',
      deleteReasonTestOrder: 'Test order',
      deleteReasonOther: 'Other',
      deleteReasonNoteLabel: 'Note',
      deleteReasonNotePlaceholder: 'Add detail (required for "Other")',
      deleteReasonConfirm: 'Delete order',
      deleteReasonCancel: 'Keep order',
      deletedReason: 'Deletion reason',
      orderDetails: 'Order Details',
      noOrders: 'No orders found',
      addOrder: 'Add Order',
      viewOrder: 'View Order',
      cancelOrder: 'Cancel Order',
      completeOrder: 'Complete Order',
    },

    // Orders History (filter labels and buttons)
    orderHistory: {
      branch: 'Branch',
      selectBranch: 'Select branch',
      user: 'User',
      selectUser: 'Select user',
      startDate: 'Start date',
      endDate: 'End date',
      search: 'Search',
      filters: 'Filters',
      today: 'Today',
      last15Days: 'Last 15 days',
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      results: 'Results',
      loading: 'Loading...',
      numberOfOrders: 'Number of orders:',
      noOrdersInRange: 'No orders in this range.',
      pleaseSelectBranchUserDate: 'Please select branch, user, and date range.',
      failedToLoadOrders: 'Failed to load orders.',
    },

    // QR Menu List page
    qrMenuList: {
      selectBranch: 'Select Branch',
      selectBranchPlaceholder: '— Select Branch —',
      noQrMenuFound: 'No QR Menu Found',
      createQrMenuToGetStarted: 'Create a QR menu for this branch to get started.',
      createQrMenu: 'Create QR Menu',
      noRestaurantSelected: 'No Restaurant Selected',
      selectRestaurantFromHeader: 'Select a restaurant from the header dropdown to view and manage QR menus.',
      pleaseSelectRestaurant: 'Please select a restaurant from the header',
      pleaseSelectBranch: 'Please select a branch',
      errorCreatingQrMenu: 'Error creating QR menu',
      restaurant: 'Restaurant',
      menuItemsCount: '{{count}} Menu Items',
      edit: 'Edit',
      downloadQr: 'Download QR',
      copy: 'Copy',
      copied: 'Copied!',
    },

    // Users/Staff
    user: {
      title: 'Users',
      users: 'Users',
      staff: 'Staff',
      userName: 'User Name',
      userEmail: 'User Email',
      userRole: 'User Role',
      userPhone: 'User Phone',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userDetails: 'User Details',
      noUsers: 'No users found',
      addUser: 'Add User',
      searchByNameOrEmail: 'Search by name or email',
      allRoles: 'All roles',
      loadingUsers: 'Loading users...',
      noStaffFound: 'No staff found',
      noUsersMatchFilters: 'No users match your current filters.',
      addFirstTeamMember: 'Add your first team member to get started.',
      roles: {
        owner: 'Owner',
        admin: 'Admin',
        branch_admin: 'Branch Admin',
        restaurant_manager: 'Restaurant Manager',
        manager: 'Manager',
        branch_manager: 'Branch Manager',
        waiter: 'Waiter',
        chef: 'Chef',
        cashier: 'Cashier',
        accountant: 'Accountant',
      },
    },

    // Expenses
    expense: {
      title: 'Title',
      expenses: 'Expenses',
      expenseCategory: 'Expense Category',
      expenseCategories: 'Expense Categories',
      createExpense: 'Create Expense',
      editExpense: 'Edit Expense',
      deleteExpense: 'Delete Expense',
      expenseDetails: 'Expense Details',
      noExpenses: 'No expenses found',
      addExpense: 'Add Expense',
      receiptScanner: 'Receipt Scanner',
      scanReceipt: 'Scan Receipt',
      uploadReceipt: 'Upload Receipt',
      receiptReview: 'Receipt Review',
      categoryName: 'Category Name',
      createCategory: 'Create Category',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      // Keys used by the POS Expenses tab (POSExpensesView)
      titleRequired: 'Expense title is required.',
      priceRequired: 'Enter an amount greater than 0.',
      offlineNotice: "You're offline — expenses can only be recorded while connected. Reconnect and try again.",
      saved: 'Expense saved.',
      titlePlaceholder: 'e.g. Vegetables, Gas cylinder…',
      amount: 'Amount',
      category: 'Category',
      categoryOther: 'Other',
      paymentMethod: 'Payment',
      bankTransfer: 'Bank transfer',
      date: 'Date',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Supplier, invoice number…',
      todayExpenses: "Today's expenses",
      noneToday: 'No expenses recorded today.',
      noRestaurant: 'Restaurant info missing — reload the POS if this persists.',
    },

    // Deals
    deal: {
      title: 'Deals',
      deals: 'Deals',
      dealName: 'Deal Name',
      dealDescription: 'Deal Description',
      dealPrice: 'Deal Price',
      createDeal: 'Create Deal',
      editDeal: 'Edit Deal',
      deleteDeal: 'Delete Deal',
      dealDetails: 'Deal Details',
      noDeals: 'No deals found',
      addDeal: 'Add Deal',
    },

    // Settings
    settings: {
      title: 'Settings',
      general: 'General',
      appearance: 'Appearance',
      language: 'Language',
      theme: 'Theme',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      switchToLightMode: 'Switch to Light Mode',
      switchToDarkMode: 'Switch to Dark Mode',
      gradientBackgrounds: 'Gradient Backgrounds',
      turnOnGradient: 'Turn On Gradient Backgrounds',
      turnOffGradient: 'Turn Off Gradient Backgrounds',
      colorThemes: 'Color Themes',
      colorThemesDescription: 'Choose from 20 beautiful color themes. Each theme includes colors for buttons, cards, gradients, and all UI elements.',
      notifications: 'Notifications',
      privacy: 'Privacy',
      security: 'Security',
      account: 'Account',
    },

    // Errors & Messages
    messages: {
      somethingWentWrong: 'Something went wrong',
      tryAgain: 'Please try again',
      operationSuccess: 'Operation completed successfully',
      operationFailed: 'Operation failed',
      confirmDelete: 'Are you sure you want to delete this item?',
      deleteSuccess: 'Item deleted successfully',
      deleteFailed: 'Failed to delete item',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Failed to update',
      createSuccess: 'Created successfully',
      createFailed: 'Failed to create',
      networkError: 'Network error. Please check your connection.',
      unauthorized: 'You are not authorized to perform this action',
      notFound: 'Page not found',
      serverError: 'Server error. Please try again later.',
    },

    // Expenses
    expense: {
      title: 'Expense Report',
      expenseReport: 'Expense Report',
      messageEntryTitle: 'Quick expense entry',
      messageEntryHint: 'Add expenses here through the day (e.g. "sebze 200"). Everyone at the branch sees who added what. At the end of the day press Submit — every line is categorized automatically and saved under the name of whoever wrote it.',
      messageEntryPlaceholder: 'vegetables 200\nchicken 1500\nAli salary 3000',
      messageEntrySubmit: 'Submit day’s expenses',
      messageEntrySaving: 'Submitting…',
      messageEntryAdded: 'expense(s) added',
      messageEntryTodayList: "Today's expenses",
      messageEntryEmpty: 'No expenses recorded today yet.',
      messageEntryLoadError: 'Could not load expenses — tap Refresh to retry.',
      messageEntryAddLine: 'Add',
      messageEntryLinePlaceholder: 'sebze 200, tavuk 300',
      messageEntryPendingList: "Today's note (not submitted yet)",
      messageEntryPendingEmpty: 'No lines yet — add the first expense above.',
      messageEntryUnparsed: 'Could not read the lines from:',
      messageEntryDeleteConfirm: 'Delete this expense?',
      messageEntryTruncated: 'Entry too long — lines not added:',
      messageEntryNeedsAmount: 'Each line needs item + amount together (e.g. "sebze 200") — not added:',
      expenses: 'Expenses',
      expense: 'Expense',
      addExpense: 'Add Expense',
      editExpense: 'Edit Expense',
      deleteExpense: 'Delete Expense',
      scanReceipt: 'Scan Receipt',
      receiptScanning: 'Receipt Scanning',
      expenseDetails: 'Expense Details',
      expenseTitle: 'Expense Title',
      expenseAmount: 'Amount',
      expenseDate: 'Date',
      expenseCategory: 'Category',
      expenseDescription: 'Description',
      expenseNotes: 'Notes',
      paymentMethod: 'Payment Method',
      paymentCash: 'Cash',
      paymentCard: 'Card',
      receiptNumber: 'Receipt Number',
      approvedBy: 'Approved By',
      status: 'Status',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      filters: 'Filters',
      startDate: 'Start Date',
      endDate: 'End Date',
      category: 'Category',
      allCategories: 'All Categories',
      merchant: 'Merchant',
      allMerchants: 'All Merchants',
      itemName: 'Item Name',
      itemNameSearch: 'Item Name (Search)',
      searchByItemName: 'Search by item name...',
      loading: 'Loading...',
      loadingExpenseReport: 'Loading expense report...',
      exportCSV: 'Export CSV',
      totalAmount: 'Total Amount',
      totalExpenses: 'Total Expenses',
      totalSalaries: 'Total Salaries',
      highestSpending: 'Highest spending',
      averageAmount: 'Average Amount',
      expensesByCategory: 'Expenses by Category',
      expensesByItem: 'Expenses by Item',
      expensesByMerchant: 'Expenses by Merchant',
      expensesByDate: 'Expenses by Date',
      totalQuantity: 'Total Quantity',
      unit: 'Unit',
      vatRate: 'VAT Rate',
      merchantName: 'Merchant Name',
      count: 'Count',
      noExpensesFound: 'No expenses found for the selected date range and filters',
      selectBranchRestaurant: 'Please select a branch and restaurant to view expense reports',
      selectBranchRestaurantBeforeAdding: 'Please select a branch and restaurant from the POS screen before adding expenses',
      salary: 'Salary',
      salaries: 'Salaries',
      salaryMonth: 'Salary month',
      salaryMonthRequired: 'Please select the salary month',
      loan: 'Loan',
      loans: 'Loans',
      borrowerName: 'Borrower name',
      borrowerNamePlaceholder: 'e.g. Faizan',
      deleteDay: 'Delete day',
      exportExcel: 'Excel Report',
      exportSalaryExcel: 'Salary Excel',
      exportPersonalExcel: 'Personal Excel',
      noExpensesForDay: 'No expenses recorded for this day',
      xlsxDate: 'Date',
      xlsxCash: 'Cash',
      xlsxCredit: 'Credit',
      xlsxTotal: 'Total',
      xlsxExpense: 'Expense',
      xlsxCreditExpense: 'Credit Expense',
      xlsxNetTotal: 'Net Total',
      xlsxTotalRow: 'TOTAL',
      xlsxSummarySheet: 'Summary',
      xlsxLedgerSheet: 'Ledger',
      xlsxCategorySheet: 'Expenses by Category',
      xlsxSalarySheet: 'Salaries',
      xlsxPersonalSheet: 'Personal Withdrawals',
      xlsxPersonalFundSection: 'PERSONAL FUND WITHDRAWALS (NOT INCLUDED IN EXPENSES)',
      xlsxPersonalFundDate: 'Date',
      xlsxPersonalFundName: 'Name',
      xlsxPersonalFundAmount: 'Amount',
      xlsxPersonalFundMethod: 'Method',
      xlsxPersonalNote: 'Note',
      xlsxPersonalByMethod: 'TOTALS BY PAYMENT METHOD',
      xlsxPersonalByPerson: 'TOTALS BY INDIVIDUAL',
      personalWithdrawal: 'Personal withdrawal',
      markAsPersonal: "This is a partner's personal draw, not a business expense",
      markAsPersonalHint: "Saved separately as a personal fund withdrawal — it won't appear in expenses or reduce net profit.",
      filterLast7Days: 'Last 7 days',
      filterLast30Days: 'Last 30 days',
      filterLast90Days: 'Last 90 days',
      filterLast6Months: 'Last 6 months',
      filterToday: 'Today',
      filterPickDate: 'Pick a date',
      filterCustomRange: 'Custom range',
      handwrittenRulesTitle: 'Handwritten Note Rules',
      handwrittenRule1: 'Write "Expenses" as the heading at the top of the note.',
      handwrittenRule2: 'One expense per line.',
      handwrittenRule3: 'Write the expense title first, then the price.',
      handwrittenRule4: 'For salary payments, include the word "salary" next to the name.',
      handwrittenRule5: 'Write the price as clearly as possible.',
      handwrittenRule6: 'Write the date at the top of the note (e.g. 24/04/2026) — otherwise today\'s date is used.',
      report: 'Report',
      search: 'Search',
      searchPlaceholder: 'Search title, merchant, receipt, line items…',
      searchHintTitle: 'Search expenses',
      searchHintSub: 'Matches title, description, category, receipt merchant, and item names for the current date range.',
      searchNoResults: 'No expenses match your search',
      searchTryDifferent: 'Try different words or clear filters on the date picker above.',
      searchResultsMeta: '{{count}} match(es) in loaded expenses',
      receiptReview: 'Receipt Review',
      reviewReceiptData: 'Review Receipt Data',
      receiptData: 'Receipt Data',
      merchantInfo: 'Merchant Information',
      items: 'Items',
      saveExpense: 'Save Expense',
      cancel: 'Cancel',
      processingReceipt: 'Processing receipt...',
      extractingData: 'Extracting data from receipt...',
      receiptDateOnReceipt: 'Receipt date',
      scannedDate: 'Scanned',
      expenseBookedDate: 'Booked',
      addExpenseHint: 'Fill in the details to record this transaction.',
      editExpenseHint: 'Update the details below and save your changes.',
      employeeName: 'Employee name',
      employeeNamePlaceholder: 'e.g. John Smith — Head Chef',
      categoryTitlePlaceholder: 'Enter category title',
      expenseTitlePlaceholder: 'e.g. Vegetable delivery, Cleaning supplies',
      amountAndDate: 'Amount & date',
      salaryAmount: 'Salary amount',
      quickAdd: 'Quick add',
      recurring: 'Recurring',
      makeRecurring: 'Repeat this expense automatically',
      frequency: 'Frequency',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      dayOfMonth: 'Day of month',
      dayOfWeek: 'Day of week',
      mode: 'When due',
      autoPost: 'Add automatically',
      askConfirm: 'Ask me to confirm',
      draftsPending: 'Recurring expenses awaiting your confirmation',
      noRecurring: 'No recurring expenses yet',
      noRecurringSub: 'When adding an expense, tick "Repeat automatically" to set up rent, utilities or fixed salaries.',
      nextRun: 'next',
      paused: 'Paused',
      pause: 'Pause',
      resume: 'Resume',
      categoryLabels: {
        foodSupplies: 'Food Supplies',
        labor: 'Labor',
        utilities: 'Utilities',
        rent: 'Rent',
        equipment: 'Equipment',
        salary: 'Salary',
        other: 'Other',
      },
      // Keys used by the POS Expenses tab (POSExpensesView). This is the
      // WINNING `expense:` block (duplicated above at ~line 1075); add keys
      // here or they get clobbered by JS object-literal key precedence.
      titleRequired: 'Expense title is required.',
      priceRequired: 'Enter an amount greater than 0.',
      offlineNotice: "You're offline — expenses can only be recorded while connected. Reconnect and try again.",
      saved: 'Expense saved.',
      titlePlaceholder: 'e.g. Vegetables, Gas cylinder…',
      amount: 'Amount',
      categoryOther: 'Other',
      bankTransfer: 'Bank transfer',
      notes: 'Notes (optional)',
      notesPlaceholder: 'Supplier, invoice number…',
      todayExpenses: "Today's expenses",
      noneToday: 'No expenses recorded today.',
      noRestaurant: 'Restaurant info missing — reload the POS if this persists.',
      printReport: 'Print Expense Report',
      printTitle: 'EXPENSE REPORT',
      noneForDate: 'No expenses for this date',
    },

    landingPage: {
      badge: 'ALL-IN-ONE RESTAURANT PLATFORM',
      heroEyebrow: 'ALL-IN-ONE RESTAURANT PLATFORM',
      heroTitleLine1: 'Run your entire restaurant —',
      heroTitleLine2Prefix: 'from one',
      heroTitleLine2Suffix: 'command center',
      heroBrandName: 'Restro 360',
      heroTitlePrefix: 'Manage Your',
      heroRotatingVenues: 'Fine Dine|Restaurant|Cafe|Food Truck|Bakery',
      heroTitleSuffix: 'Operations with',
      heroSubtitle:
        'Sell more, serve faster, and stay in control — POS, QR menus, AI-powered dish photos, smart expenses, kitchen display, and multi-branch management in one platform built for restaurants that never stand still.',
      getStarted: 'Get Started Free',
      watchFilm: 'Watch the Demo',
      altPlayIcon: 'Play icon',
      altDashboardPreview: 'Restaurant management dashboard preview',
      cinematicTitle: 'See Restro 360 in action',
      videoSectionEyebrow: 'Product tour',
      cinematicSubtitle:
        'From the first guest scan to the last receipt logged — watch how modern restaurants run smoother shifts, sharper menus, and smarter back-office in minutes, not months.',
      featuresSectionEyebrow: 'FEATURES',
      featuresGrid: {
        pos: { title: 'POS', desc: 'Check sales from anywhere' },
        qrMenu: { title: 'QR Menu', desc: 'Beautiful templates, zero reprints' },
        aiPhotos: { title: 'AI Dish Photos', desc: 'Menu-ready in one upload' },
        smartExpenses: { title: 'Smart Expenses', desc: 'Snap invoices, skip data entry' },
        waiterOrdering: { title: 'Waiter Ordering', desc: 'Guests order, staff in charge' },
        ownerDashboard: { title: 'Owner Dashboard', desc: 'Your business at a glance' },
        multiBranch: { title: 'Multi-Branch', desc: 'Scale without the chaos' },
        sessionMode: { title: 'Session Mode', desc: 'Know who ran the counter' },
        staffRoles: { title: 'Staff Roles', desc: 'Every worker, their own login' },
        kds: { title: 'KDS', desc: 'Kitchen in sync, on time' },
      },
      ariaVideoIntro: 'Restro 360 product preview video',
      altVideoPlaceholder: 'Video background placeholder',
      experiencePill: 'Preview Restro 360',
      posShowcaseAria: 'Point of sale showcase',
      posShowcaseEyebrow: 'Point of sale',
      posShowcaseTitle: 'A POS built for busy floors',
      posShowcaseSubtitle:
        'Take orders, split bills, and close out shifts in seconds — see the Restro 360 POS up close.',
      posShowcaseDesktopLabel: 'Desktop',
      posShowcaseMobileLabel: 'Mobile',
      altPosDemo1: 'Restro 360 point of sale screen showing the order view',
      altPosDemo2: 'Restro 360 point of sale screen showing the checkout view',
      altPosDemoMobile: 'Restro 360 point of sale running on a mobile phone',
      qrMenuShowcaseAria: 'QR menu showcase',
      qrMenuShowcaseEyebrow: 'QR menu',
      qrMenuShowcaseTitle: 'Scan, browse, order — no app required',
      qrMenuShowcaseSubtitle:
        'Give guests a beautiful digital menu they can open from their phone in seconds, with photos, categories, and instant ordering built in.',
      qrShowcaseAdminLabel: 'Admin',
      qrShowcaseGuestLabel: 'Guest menu',
      altQrMenuDemo1: 'Restro 360 QR menu admin dashboard with templates and QR code',
      altQrMenuDemo2: 'Restro 360 guest-facing QR menu on mobile',
      salesShowcaseAria: 'Sales reporting showcase',
      salesShowcaseEyebrow: 'Sales & reports',
      salesShowcaseTitle: 'Know your numbers, every shift',
      salesShowcaseSubtitle:
        'Track revenue, top items, and trends in real time — clear sales reports that help you make faster, smarter decisions.',
      altSalesDemo1: 'Restro 360 sales dashboard showing revenue overview',
      altSalesDemo2: 'Restro 360 sales dashboard showing item-level breakdown',
      altSalesDemo3: 'Restro 360 sales dashboard showing trends over time',
      tableShowcaseAria: 'Table and menu management showcase',
      tableShowcaseEyebrow: 'Floor & menu',
      tableShowcaseTitle: 'Lay out your floor. Build your menu.',
      tableShowcaseSubtitle:
        'Design indoor and outdoor table layouts on a visual floor plan, track live status across every seat, and manage your full menu with photos, categories, and pricing — all from one back office.',
      tableShowcaseTablesLabel: 'Tables',
      tableShowcaseMenuLabel: 'Menu',
      altTableDemo: 'Restro 360 table management floor plan with indoor and outdoor sections',
      altMenuDemo: 'Restro 360 menu management screen with categories and dish items',
      tableBullet1Title: 'Visual floor plan',
      tableBullet1Text: 'Arrange tables by section with drag-and-drop layouts your whole team can read at a glance.',
      tableBullet2Title: 'Live table status',
      tableBullet2Text: 'See available, occupied, and reserved tables instantly — no walk-throughs, no guesswork.',
      tableBullet3Title: 'Complete menu control',
      tableBullet3Text: 'Organize categories, dish photos, prices, and availability in one place, synced straight to your POS and QR menu.',
      orderHistoryAria: 'Order history showcase',
      orderHistoryEyebrow: 'Order history',
      orderHistoryTitle: 'Every order, logged and visible',
      orderHistorySubtitle:
        'Every order, edit, void, and payment is timestamped and tied to the staff member who made it — full visibility for owners, zero room for theft.',
      orderHistoryTrustBadge: 'Everything can be seen — no chance of theft',
      orderHistoryBullet1Title: 'Complete, timestamped log',
      orderHistoryBullet1Text: 'Every order, edit, void, and refund is recorded the moment it happens — nothing slips through.',
      orderHistoryBullet2Title: 'Tied to the staff member',
      orderHistoryBullet2Text: 'Each action is linked to the person who made it, so accountability is never in question.',
      orderHistoryBullet3Title: 'Full visibility for owners',
      orderHistoryBullet3Text: 'Search, filter, and review any order from any shift — total transparency across your business.',
      altOrderHistory: 'Restro 360 order history screen showing a complete, timestamped log of every order',
      masterpieceAria: 'Designed for the Masterpiece features section',
      masterpieceTitleBefore: 'Everything your ',
      masterpieceTitleAccent: 'restaurant',
      masterpieceTitleAfter: ' needs to win',
      masterpieceSubtitle:
        'One platform. Every shift covered. Restro 360 connects your floor, kitchen, menu, and money.',
      exploreFeatures: 'Explore all features →',
      posTitle: 'POS built for real shifts',
      posDesc:
        'Ring up dine-in, bar, takeaway, and delivery with hardware-friendly flows that stay fast when the room is full.',
      feature01: 'FEATURE 01',
      altPosPreview: 'Next-Gen POS preview',
      qrTitle: 'QR menus & guest ordering',
      qrDesc:
        'Share digital menus and optional scan-to-order that ties straight into the same checks your servers use—no duplicate menus to maintain.',
      realTimeStatus: 'Real-time status',
      staffTitle: 'Staff you can trust',
      staffDesc:
        'Roles, permissions, and shift-friendly tools so the right people can comp, void, or adjust—with a clear trail for owners.',
      analyticsTitle: 'Live analytics',
      analyticsDesc:
        'See sales, labor, and menu performance as the night unfolds—not only after you close.',
      reportsTitle: 'Reports that close the books',
      reportsDesc:
        'End-of-day packs, category breakdowns, and export-friendly numbers for your accountant or multi-unit ops lead.',
      trustedTitle: 'Trusted by teams who don\'t have time for slow software',
      socialProofEyebrow: 'SOCIAL PROOF',
      trustedTagline: 'Built for busy dining rooms. Proven on real Friday nights.',
      marqueeAria: 'Trusted restaurant brands marquee',
      statsAria: 'Results you can feel on the floor',
      resultsEyebrow: 'RESULTS',
      statsHeading: 'Results you can feel on the floor',
      statsSubtitle:
        'Restro 360 helps restaurants cut order errors, tighten service, and give owners visibility without living inside a spreadsheet.',
      kpiOneValue: 'One',
      kpiOneLabel: 'platform — POS, QR menu, AI photos, expenses & kitchen',
      kpi247Value: '24/7',
      kpi247Label: 'sales visibility — every branch, every device',
      kpiZeroValue: 'Zero',
      kpiZeroLabel: 'duplicate menus — update once, publish everywhere',
      altRevenue: 'Revenue',
      testimonialsAria: 'Hear from our customers testimonials section',
      testimonialsHeading: 'Don\'t take our word for it',
      testimonialsSubtitle: 'Stories from teams running busy dining rooms.',
      testimonialElenaQuote:
        'We moved five locations onto Restro 360 and never looked back. I check sales from my phone, trust every branch\'s numbers, and our menus finally look as good online as they taste in person.',
      testimonialElenaAuthor: 'Elena Rodriguez',
      testimonialElenaRole: 'Owner, Hearth & Vine',
      testimonialMarcusQuote:
        'QR ordering with waiter confirmation changed everything. Guests love ordering from their phones, our staff stays in control, and the kitchen gets clean tickets every time.',
      testimonialMarcusAuthor: 'Marcus Thorne',
      testimonialMarcusRole: 'Director of Ops, Urban Bowl',
      testimonialSarahQuote:
        'We uploaded phone photos of our dishes and Restro 360 made them look incredible on the QR menu. Session mode and separate logins made shift accountability effortless.',
      testimonialSarahAuthor: 'Sarah Chen',
      testimonialSarahRole: 'Manager, Zen Kitchen',
      altAvatarElena: 'Elena Rodriguez avatar',
      altAvatarMarcus: 'Marcus Thorne avatar',
      altAvatarSarah: 'Sarah Chen avatar',
      leadGenAria: 'Book a demo contact form',
      contactEyebrow: 'CONTACT',
      leadGenTitle: 'Ready to run a smarter restaurant?',
      leadGenSubtitle:
        'Tell us about your venue and we\'ll show you Restro 360 live — POS, AI dish photos, QR menus, expenses, KDS, and multi-branch setup tailored to how you actually operate.',
      leadGenBullet1: 'Personalized onboarding for your menu, photos, and hardware',
      leadGenBullet2: 'Transparent pricing — including multi-location options',
      leadGenBullet3: 'Real support when Friday night gets loud',
      leadGenFooterNote: 'See your restaurant on Restro 360 in 30 minutes — no obligation.',
      contactSubmitting: 'Sending...',
      contactSubmitSuccess: 'Thanks! Your request was sent — we will contact you soon.',
      contactSubmitError: 'Could not send your request. Please try again or email us directly.',
      labelName: 'Name',
      placeholderName: 'John Doe',
      labelEmail: 'Email',
      placeholderEmail: 'john@restaurant.com',
      labelCountry: 'Country',
      placeholderCountry: 'United States',
      labelState: 'State/City',
      placeholderState: 'New York, NY',
      labelRestaurant: 'Restaurant Name',
      placeholderRestaurant: 'The Grand Bistro',
      labelBusinessType: 'Business Type',
      businessFineDining: 'Fine Dining',
      businessCasual: 'Casual Dining',
      businessFastCasual: 'Fast Casual',
      labelStores: 'No. of Stores',
      bookDemo: 'Book a Free Demo',
      pricingSectionEyebrow: 'PRICING',
      pricingSectionTitle: 'Plans that grow with your restaurant',
      pricingSectionSubtitle:
        'Start with one location. Scale to a chain. Pay for what you use — not what you don\'t.',
    },

    landingNav: {
      ariaTopNav: 'Top navigation',
      menu: 'Menu',
      logIn: 'Log In',
      selectLanguage: 'Select language',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      langEn: 'EN',
      langTr: 'TR',
      links: {
        features: 'Features',
        pricing: 'Pricing',
        testimonials: 'Testimonials',
        contact: 'Book a Demo',
      },
    },

    landingFooter: {
      aria: 'Footer',
      tagline1: 'Restro 360 — Run the whole house',
      tagline2: 'from one command center.',
      tagline3: '',
      altGlobe: 'Globe icon',
      altInstagram: 'Instagram',
      altEmail: 'Email icon',
      colProduct: 'Product',
      productOverview: 'Overview',
      productPos: 'POS & Orders',
      productAiPhotos: 'AI Dish Photos',
      productQr: 'QR & Online Ordering',
      productExpenses: 'Expense Management',
      productKds: 'Kitchen Display (KDS)',
      productMultiBranch: 'Multi-Branch Management',
      productReports: 'Reports & Dashboard',
      productPricing: 'Pricing',
      colCompany: 'Company',
      companyLogin: 'Log In',
      companySignup: 'Sign Up',
      companyDemo: 'Book a Demo',
      companyContact: 'Contact Us',
      colLegal: 'Legal',
      legalPrivacy: 'Privacy Policy',
      legalTerms: 'Terms of Service',
      copyright: '© 2025 Restro 360. All rights reserved.',
    },

    pricingPage: {
      faq: {
        sectionAria: 'Pricing frequently asked questions',
        eyebrow: 'Help center',
        title: 'Frequently asked questions',
        subtitle:
          'Pricing, rollout, and how Restro 360 fits POS, floor, menu, and reporting for your team.',
        bookDemoCta: 'Book a demo →',
        items: {
          differentFromOthers: {
            question: 'How is Restro 360 different from other restaurant systems?',
            answer:
              'Restro 360 ties POS, floor and tables, menu, QR ordering, staff roles, and reporting into one workflow. You manage checks, 86s, and end-of-day numbers from the same place your servers work—without juggling separate tools for each job.',
          },
          deviceTableLimits: {
            question: 'How many devices and tables can we use?',
            answer:
              'Limits depend on the plan you choose. Starter is built for light QR-menu use; paid tiers add full POS with more terminals and unlimited tables where offered. Chain and enterprise packages are scoped for many branches and devices—talk to us for a fit check.',
          },
          rushPerformance: {
            question: 'How does performance hold up during rush?',
            answer:
              'The product is designed for real shifts: fast ticket entry, stable sync between floor and kitchen, and dashboards that stay responsive when order volume spikes. Your exact setup—hardware and connectivity—still matters, and we help you plan for it.',
          },
          setupTimeline: {
            question: 'How long does setup take?',
            answer:
              'Timeline varies by menu size, number of locations, and integrations. Most teams start with menu import, table layout, staff roles, and a training pass. Our team works with you on the first configuration so you are not guessing alone on day one.',
          },
          dataSecurity: {
            question: 'How is our data kept secure?',
            answer:
              'Data lives in secured cloud infrastructure with backups and access controls. Staff permissions limit who can void, comp, or change sensitive settings so owners keep a clear audit trail.',
          },
          paymentMethods: {
            question: 'Which payment methods are supported?',
            answer:
              'Restro 360 supports the payment flows restaurants expect—cash, card, and integrated terminals where your processor allows. The exact integrations depend on your region and provider; we map that during onboarding.',
          },
          qrSameMenuAsPos: {
            question: 'Do QR menus and in-house POS use the same menu?',
            answer:
              'Yes—that is the point of one platform. You maintain items, prices, modifiers, and 86s in one place; guests scanning your QR see the same catalog your servers ring on POS, so you are not double-updating spreadsheets or a separate menu app.',
          },
          multiLocation: {
            question: 'Can we run multiple locations or a small chain?',
            answer:
              'Yes. Higher tiers add capacity for more devices and branches, and Chain / Enterprise is meant for centralized menu, permissions, and reporting across stores. We scope roles and rollout so each site keeps local control where you need it.',
          },
          hardwareRequirements: {
            question: 'What hardware do we need?',
            answer:
              'Most teams use tablets or terminals for POS, plus kitchen printers and cash drawers where you take cash. Compatible models depend on your market; during onboarding we confirm printer drivers, payment devices, and any minimum specs so you do not buy the wrong kit.',
          },
          inventoryIncluded: {
            question: 'Is inventory or stock tracking included?',
            answer:
              'Stock counting and inventory workflows are available on plans built for growing operations (see your plan card for detail). Lighter tiers focus on QR menu and core POS; we can recommend the right tier if pars and counts matter to your kitchen and purchasing.',
          },
          postLaunchSupport: {
            question: 'What support do we get after go-live?',
            answer:
              'You get guided setup for menu, floor, and roles, plus channels for questions as you train staff. Enterprise customers typically receive a named rollout path; every plan is designed so you are not stuck searching docs alone on a Friday night.',
          },
          menuImportMigration: {
            question: 'Can we import an existing menu or migrate from another POS?',
            answer:
              'We support structured imports and help you map categories, modifiers, and taxes from spreadsheets or exports where available. Complex migrations may need a short discovery call; we will tell you upfront what we can automate versus what is manual cleanup.',
          },
        },
      },
      plans: {
        header: {
          eyebrow: 'Pinner Pricing',
          title: 'Choose the perfect plan',
          subtitle:
            'Flexible, transparent packages for every need—from QR menus to multi-location management.',
        },
        billing: {
          threeMonthly: '3 months',
          sixMonth: '6 months',
          yearly: 'Yearly',
        },
        period: {
          threeMonths: '/3 months',
          sixMonths: '/6 months',
          year: '/year',
          perBranchMonth: '/ branch / month',
        },
        labels: {
          contactUs: 'Contact sales →',
          getStarted: 'Start free →',
          freeTrial: '15 days free',
          capacity: 'Capacity',
          features: 'Highlighted features',
        },
        badgeMostPopular: 'Most popular',
        tiers: {
          standard: {
            name: 'Standard',
            subtitle: 'Full system · light receipt scanning',
            description: 'Everything you need to run a busy branch.',
            capacity:
              'Perfect for restaurants that want the full system with light receipt scanning.',
            ctaLabel: 'Start free →',
            trialNote: 'Includes 5 free receipt scans to try before you buy.',
            features: [
              'Full POS & order management',
              'Menu, tables & QR digital menu',
              'Staff & role management',
              'Expense & salary tracking',
              'Recurring expenses & quick-add',
              'Sales & branch analytics',
              '20 AI receipt scans / month',
            ],
          },
          pro: {
            name: 'Pro',
            subtitle: 'For branches that run on receipts.',
            description:
              'Everything in Standard, plus never worry about scan limits again.',
            capacity: 'Unlimited AI receipt scanning with no monthly cap.',
            ctaLabel: 'Go Pro →',
            features: [
              'Everything in Standard',
              'Unlimited AI receipt scanning',
              'Auto-categorized expenses from every receipt',
              'Priority processing',
            ],
          },
          enterprise: {
            name: 'Chain / enterprise',
            subtitle: 'Built for groups running 5+ branches.',
            description:
              'Centralized control and tailored terms for multi-branch operations.',
            priceLabel: "Let's talk",
            capacity: 'Everything in Pro, across all branches',
            ctaLabel: 'Contact sales →',
            features: [
              'Multi-branch dashboard & consolidated reporting',
              'Volume pricing & custom billing cycle',
              'Dedicated onboarding & priority support',
              'Custom feature requests',
            ],
          },
        },
      },
      cta: {
        title: 'Ready to run service on Restro 360?',
        subtitle:
          'Start a trial or book a walkthrough—we will align plans with your locations, devices, and how you use POS, QR, and reports.',
        button: 'Get started →',
        note: '✓ No credit card required on applicable trials · ✓ Guided setup for your menu and floor',
      },
    },
  },

  tr: {
    // Common
    common: {
      loading: 'Yükleniyor...',
      save: 'Kaydet',
      print: 'Yazdır',
      cancel: 'İptal',
      delete: 'Sil',
      deleting: 'Siliniyor…',
      edit: 'Düzenle',
      add: 'Ekle',
      create: 'Oluştur',
      update: 'Güncelle',
      search: 'Ara...',
      close: 'Kapat',
      back: 'Geri',
      next: 'İleri',
      previous: 'Önceki',
      submit: 'Gönder',
      confirm: 'Onayla',
      yes: 'Evet',
      no: 'Hayır',
      ok: 'Tamam',
      apply: 'Uygula',
      reset: 'Sıfırla',
      clear: 'Temizle',
      select: 'Seç',
      all: 'Tümü',
      none: 'Hiçbiri',
      actions: 'İşlemler',
      status: 'Durum',
      name: 'Ad',
      description: 'Açıklama',
      price: 'Fiyat',
      quantity: 'Miktar',
      total: 'Toplam',
      subtotal: 'Ara Toplam',
      tax: 'Vergi',
      discount: 'İndirim',
      amount: 'Tutar',
      date: 'Tarih',
      time: 'Saat',
      type: 'Tür',
      category: 'Kategori',
      image: 'Resim',
      settings: 'Ayarlar',
      profile: 'Profil',
      logout: 'Çıkış Yap',
      signOut: 'Çıkış Yap',
      myProfile: 'Profilim',
      notifications: 'Bildirimler',
      noData: 'Veri bulunamadı',
      error: 'Hata',
      success: 'Başarılı',
      warning: 'Uyarı',
      info: 'Bilgi',
      required: 'Gerekli',
      optional: 'İsteğe Bağlı',
      active: 'Aktif',
      inactive: 'Pasif',
      enabled: 'Etkin',
      disabled: 'Devre Dışı',
      online: 'Çevrimiçi',
      offline: 'Çevrimdışı',
      today: 'Bugün',
      tomorrow: 'Yarın',
      yesterday: 'Dün',
      thisWeek: 'Bu hafta',
      minutesAgo: '{{count}} dakika önce',
      locale: 'tr-TR',
      owner: 'Sahip',
      due: 'Vade',
      view: 'Görüntüle',
      swipe: 'Kaydır',
      pullToRefresh: 'Yenilemek için çekin',
      refreshing: 'Yenileniyor...',
      hide: 'Gizle',
      remove: 'Kaldır',
      note: 'Not',
      saving: 'Kaydediliyor...',
      saveChanges: 'Değişiklikleri Kaydet',
      processing: 'İşleniyor...',
      printing: 'Yazdırılıyor…',
      justAMoment: 'Bir dakika...',
    },

    // Auth
    auth: {
      welcomeBack: 'Tekrar Hoş Geldiniz',
      signInToAccount: 'Hesabınıza giriş yapın',
      signIn: 'Giriş Yap',
      signingIn: 'Giriş yapılıyor...',
      signUp: 'Kayıt Ol',
      signingUp: 'Kayıt olunuyor...',
      createAccount: 'Hesabınızı Oluşturun',
      creatingAccount: 'Hesap Oluşturuluyor...',
      signupPageTitle: 'Hesap Oluştur',
      signupSubtitle: 'Ücretsiz restoran çalışma alanınızla başlayın.',
      signupKicker: 'RESTORAN İÇİN STANDART',
      signupHeadline: 'Netliğe odaklı operasyonlar.',
      signupBody:
        'POS, salon, menü ve raporlama tek yerde—ekibiniz araçlarda daha az, misafirlerde daha çok zaman geçirsin.',
      signupTrustedBy: 'DÜNYA ÇAPINDA EKİPLERİN GÜVENİ',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
      email: 'E-posta',
      emailPlaceholder: 'E-postanızı girin',
      password: 'Şifre',
      passwordPlaceholder: 'Şifrenizi girin',
      confirmPassword: 'Şifreyi Onayla',
      forgotPassword: 'Şifrenizi mi unuttunuz?',
      resetPassword: 'Şifreyi Sıfırla',
      dontHaveAccount: 'Hesabınız yok mu?',
      alreadyHaveAccount: 'Zaten hesabınız var mı?',
      firstName: 'Ad',
      lastName: 'Soyad',
      firstNamePlaceholder: 'Ahmet',
      lastNamePlaceholder: 'Yılmaz',
      signupEmailPlaceholder: 'ahmet@sirket.com',
      signupPasswordPlaceholder: '........',
      signupConfirmPasswordPlaceholder: '........',
      firstNameRequired: 'Ad gereklidir',
      lastNameRequired: 'Soyad gereklidir',
      phone: 'Telefon',
      emailRequired: 'E-posta gereklidir',
      emailAddress: 'E-posta Adresi',
      passwordRequired: 'Şifre gereklidir',
      emailInvalid: 'Lütfen geçerli bir e-posta girin',
      passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
      passwordMinLength: 'Şifre en az 8 karakter olmalıdır',
      passwordsDoNotMatch: 'Şifreler eşleşmiyor',
      loginSuccess: 'Giriş başarılı',
      loginError: 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.',
      registerSuccess: 'Kayıt başarılı',
      registerError: 'Kayıt başarısız. Lütfen tekrar deneyin.',
      resetPasswordInstructions: 'E-posta adresinizi girin, size şifre sıfırlama bağlantısı göndereceğiz.',
      resetPasswordSent: 'Sağladığınız e-posta adresiyle bir hesap varsa, o adrese şifre sıfırlama talimatları gönderdik.',
      sendResetLink: 'Sıfırlama Bağlantısı Gönder',
      sending: 'Gönderiliyor...',
      returnToSignIn: 'Giriş Sayfasına Dön',
      backToSignIn: 'Giriş Sayfasına Geri Dön',
      createNewPassword: 'Yeni Şifre Oluştur',
      newPassword: 'Yeni Şifre',
      newPasswordRequired: 'Yeni şifre gereklidir',
      confirmNewPassword: 'Yeni Şifreyi Onayla',
      passwordResetSuccess: 'Şifreniz başarıyla sıfırlandı.',
      enterNewPassword: 'Aşağıya yeni şifrenizi girin ve onaylayın.',
      resetting: 'Sıfırlanıyor...',
      signInWithNewPassword: 'Yeni şifrenizle giriş yapın',
    },

    // Navigation
    nav: {
      dashboard: 'Kontrol Paneli',
      manageRestaurant: 'Restoran Yönet',
      branches: 'Şubeler',
      staff: 'Personel',
      posSystem: 'POS Sistemi',
      qrMenu: 'QR Menü',
      branchMenus: 'Şube Menüleri',
      branchTables: 'Şube Masaları',
      colorThemes: 'Renk Temaları',
      main: 'Ana',
      branchAccess: 'Şube Erişimi',
      restaurantPro: 'RestaurantPro',
      ordersHistory: 'Sipariş Geçmişi',
      myOrders: 'Siparişlerim',
      expenses: 'Giderler',
      invoices: 'Faturalar',
      downloads: 'İndirmeler',
      adminPortal: 'Yönetici Portalı',
    },

    // Dashboard
    dashboard: {
      title: 'Kontrol Paneli',
      welcome: 'Hoş Geldiniz',
      welcomeBack: 'Tekrar hoş geldiniz',
      overview: 'Genel Bakış',
      overviewText: 'Restoran yönetim sisteminizin genel bakışı',
      statistics: 'İstatistikler',
      recentActivity: 'Son Aktiviteler',
      quickActions: 'Hızlı İşlemler',
      totalSales: 'Toplam Satış',
      totalOrders: 'Toplam Sipariş',
      totalCustomers: 'Toplam Müşteri',
      totalRevenue: 'Toplam Gelir',
      todaySales: "Bugünün Satışları",
      todayOrders: "Bugünün Siparişleri",
      monthlyRevenue: 'Aylık Gelir',
      weeklyRevenue: 'Haftalık Gelir',
      topSellingItems: 'En Çok Satan Ürünler',
      lowStockItems: 'Düşük Stoklu Ürünler',
      managerDashboard: 'Müdür Kontrol Paneli',
      managerSubtitle: 'Menüleri, masaları, personeli ve siparişleri yönetin',
      waiterDashboard: 'Garson Kontrol Paneli',
      waiterSubtitle: 'Aktif siparişleri ve masaları yönetin',
      activeMenuItems: 'Aktif Menü Öğeleri',
      staffMembers: 'Personel Üyeleri',
      ordersToday: 'Bugünün Siparişleri',
      todayRevenue: "Bugünün Geliri",
      activeOrders: 'Aktif Siparişler',
      occupiedTables: 'Dolu Masalar',
      ordersReady: 'Hazır Siparişler',
      avgWaitingTime: 'Ort. Bekleme Süresi',
      underDevelopment: 'Geliştirme Aşamasında',
      underDevelopmentText: 'kontrol paneli şu anda geliştirme aşamasındadır.',
      electronHubBadge: 'Resto360 Masaüstü',
      electronHubSubtitle: 'Kasa kontrol merkezi — POS açın, günü görün ve uzaktan yazdırmayı bu bilgisayardan yönetin.',
      electronOpenPos: 'Satış Noktasını Aç',
      electronOpenPosHint: 'Masalar, siparişler ve mutfak yazdırma',
      electronOrdersHistory: 'Sipariş geçmişi',
      electronOrdersHistoryHint: 'Tamamlanan ve aktif siparişleri inceleyin',
      electronPrintStationTitle: 'Mutfak yazdırma istasyonu',
      electronPrintStationHint: 'Web ve QR siparişlerinin burada yazdırılması için POS → Ayarlar\'da Yazdırma istasyonunu etkinleştirin.',
      electronTodayAtBranch: 'Şubenizde bugün',
      restaurants: 'Restoranlar',
      branches: 'Şubeler',
      employees: 'Çalışanlar',
      tables: 'Masalar',
      addRestaurant: 'Restoran Ekle',
      viewAll: 'Tümünü Görüntüle',
      noRestaurants: 'Henüz restoran yok',
      noBranches: 'Henüz şube yok',
      noRecentActivity: 'Son aktivite yok',
      noPendingTasks: 'Bekleyen görev yok',
      pendingTasks: 'Bekleyen Görevler',
      onboardingTasks: 'Başlarken',
      onboardingProgress: '{{completed}} / {{total}} tamamlandı',
      onboardingAllDone: 'Hazırsınız! Restoranınız kullanıma hazır.',
      onboarding: {
        addRestaurantTitle: 'Restoranınızı oluşturun',
        addRestaurantDetails: 'Restoran adı, konum ve iletişim bilgilerini ekleyin.',
        addBranchTitle: 'İlk şubenizi ekleyin',
        addBranchDetails: 'Müşterilere hizmet verdiğiniz bir konum oluşturun.',
        setupMenuTitle: 'Menünüzü oluşturun',
        setupMenuDetails: 'Personelin sipariş alabilmesi için yemek, fiyat ve kategorileri ekleyin.',
        addTablesTitle: 'Masaları ayarlayın',
        addTablesDetails: 'POS kat planı için restoran masalarını yapılandırın.',
        inviteStaffTitle: 'Ekibinizi davet edin',
        inviteStaffDetails: 'Şubelerinize müdür, garson veya mutfak personeli ekleyin.',
        setupQrMenuTitle: 'QR menü yayınlayın',
        setupQrMenuDetails: 'Misafirlerin telefonlarından tarayıp sipariş vermesini sağlayın.',
      },
      systemStatus: 'Sistem Durumu',
      quickAccess: 'Hızlı Erişim',
      recentTabs: 'Son Ziyaretler',
      noRecentTabs: 'Ziyaret ettiğiniz sayfalar hızlı erişim için burada görünür.',
      page: 'Sayfa',
      activeSessions: 'Aktif Oturumlar',
      lastBackup: 'Son Yedekleme',
      hoursAgo: 'saat önce',
      reviewInventoryReport: 'Envanter raporunu incele',
      monthlyInventoryCheck: 'Downtown Şubesi için aylık envanter kontrolü',
      approveStaffSchedule: 'Personel programını onayla',
      weeklyScheduleApproval: 'Mall Şubesi için haftalık program onay bekliyor',
      updateMenuPrices: 'Menü fiyatlarını güncelle',
      seasonalPriceAdjustments: 'Tüm şubeler için mevsimsel fiyat ayarlamaları',
      reviewPromotionResults: 'Promosyon sonuçlarını incele',
      checkWeekendOffers: 'Hafta sonu özel tekliflerinin performansını kontrol et',
      largeOrderReceived: 'Büyük Sipariş Alındı',
      downtownBranchCatering: 'Downtown Şubesi: 50 kişilik catering siparişi ($1,250)',
      menuUpdated: 'Menü Güncellendi',
      newSeasonalItems: 'Mall Şubesi: Menüye 8 yeni mevsimsel öğe eklendi',
      staffScheduleUpdated: 'Personel Programı Güncellendi',
      weekendShiftsUpdated: 'Tüm Şubeler: 24 çalışan için hafta sonu vardiyaları güncellendi',
      newPromotionCreated: 'Yeni Promosyon Oluşturuldu',
      familyWeekendSpecial: 'Tüm Şubeler: "Aile Hafta Sonu" özel %20 indirim',
      equipmentMaintenance: 'Ekipman Bakımı',
      kitchenEquipmentServicing: 'Downtown Şubesi: Mutfak ekipmanı servisi tamamlandı',
      ownerDashboard: 'Sahip Kontrol Paneli',
      ownerSubtitle: 'Restoran yönetim sisteminize genel bir bakış',
      totalRestaurants: 'Toplam Restoran',
      totalBranches: 'Toplam Şube',
      totalEmployees: 'Toplam Çalışan',
      totalTables: 'Toplam Masa',
      tasksRequiringAttention: 'Dikkat Gerektiren Görevler',
      viewAllTasks: 'Tüm görevleri görüntüle',
      yourRestaurants: 'Restoranlarınız',
      viewAllRestaurants: 'Tüm restoranları görüntüle',
      noRestaurantsAdded: 'Henüz hiç restoran eklemediniz.',
      viewAllNotifications: 'Tüm bildirimleri görüntüle',
      loadingDashboard: 'Kontrol paneliniz yükleniyor...',
      revenue: 'Gelir',
      processOrders: 'Siparişleri işle',
      manageLocations: 'Konumları yönet',
      updateOfferings: 'Teklifleri güncelle',
      manageTeam: 'Ekibi yönet',
      tableManagement: 'Masa yönetimi',
      reports: 'Raporlar',
      viewAnalytics: 'Analitikleri görüntüle',
    },

    // Restaurant
    restaurant: {
      title: 'Restoran',
      restaurants: 'Restoranlar',
      manageRestaurant: 'Restoran Yönet',
      restaurantName: 'Restoran Adı',
      restaurantDescription: 'Restoran Açıklaması',
      address: 'Adres',
      phone: 'Telefon',
      email: 'E-posta',
      website: 'Web Sitesi',
      createRestaurant: 'Restoran Oluştur',
      editRestaurant: 'Restoran Düzenle',
      updateRestaurant: 'Restoranı Güncelle',
      deleteRestaurant: 'Restoran Sil',
      restaurantDetails: 'Restoran Detayları',
      restaurantAnalytics: 'Restoran Analitiği',
      noRestaurants: 'Restoran bulunamadı',
      addRestaurant: 'Restoran Ekle',
      addNewRestaurant: 'Yeni Restoran Ekle',
      loadingRestaurant: 'Restoran bilgileriniz yüklenirken lütfen bekleyin.',
      loadingRestaurantInfo: 'Restoran bilgileri yükleniyor...',
      selectRestaurant: 'Restoran Seçin',
      selectRestaurantMessage: 'Restoran yönetim sayfasına erişmek için üst gezinti çubuğundaki açılır menüden bir restoran seçin. Seçildikten sonra otomatik olarak restoran yönetim sayfasına yönlendirileceksiniz.',
      noRestaurantsMessage: 'Henüz restoranınız yok. Restoran yönetim özelliklerine erişmek için önce bir restoran oluşturun.',
      restaurantLogo: 'Restoran Logosu',
      restaurantLogoRequired: 'Restoran Logosu',
      uploadLogo: 'Logo Yükle',
      replaceLogo: 'Logoyu Değiştir',
      logoDescription: 'QR menü şablonlarında kullanmak için logo yükleyin',
      noLogoUploaded: 'Logo yüklenmedi. QR menü şablonlarında kullanmak için bir logo yükleyin.',
      cuisineType: 'Mutfak Türü',
      selectCuisine: 'Mutfak türü seçin',
      phoneNumber: 'Telefon Numarası',
      emailAddress: 'E-posta Adresi',
      city: 'Şehir',
      state: 'İl / Eyalet',
      zipCode: 'Posta Kodu',
      description: 'Açıklama',
      descriptionOptional: 'Açıklama (İsteğe Bağlı)',
      clickToUploadLogo: 'Logo yüklemek için tıklayın',
      logoFormatsHint: 'JPEG, PNG, GIF, SVG, maks. 2MB',
      logoRequired: 'Restoran logosu zorunludur',
      enterRestaurantName: 'Restoran adını girin',
      enterPhoneNumber: 'Telefon numarası girin (örn. +90-555-123-4567)',
      enterEmailAddress: 'E-posta adresi girin',
      enterAddress: 'Sokak adresini girin',
      addRestaurantSubtitle: 'Temel bilgiler, iletişim ve konum ile restoran profilinizi oluşturun.',
      editRestaurantSubtitle: 'Restoran profilinizi, iletişim bilgilerinizi ve konum bilgilerinizi güncelleyin.',
      requiredFieldsNote: '* ile işaretli alanlar zorunludur. Diğer alanlar isteğe bağlıdır ancak profilinizi tamamlamanıza yardımcı olur.',
      backToRestaurant: 'Restorana Geri Dön',
      backToRestaurants: 'Restoranlara Geri Dön',
      emailDomainHint: 'Restoran adına göre önerilen alan adı:',
      emailDomainClear: 'Kaldırmak ve özel e-posta yazmak için tıklayın',
      emailLocalPlaceholder: 'örn. admin, info, iletisim',
      failedToLoadRestaurant: 'Restoran verileri yüklenemedi. Lütfen tekrar deneyin.',
      errorSavingRestaurant: 'Restoran kaydedilirken hata oluştu. Lütfen tekrar deneyin.',
      saving: 'Kaydediliyor...',
      cancel: 'İptal',
      nameRequired: 'Restoran adı zorunludur',
      phoneRequired: 'Telefon numarası zorunludur',
      emailRequired: 'E-posta adresi zorunludur',
      phoneInvalid: 'Telefon numarası 10-15 hane olmalıdır',
      phoneFormat: 'Lütfen geçerli bir telefon numarası girin',
      emailInvalid: 'Lütfen geçerli bir e-posta adresi girin',
      logoInvalid: 'Lütfen geçerli bir resim yükleyin (JPEG, PNG, GIF, SVG)',
      logoTooLarge: 'Logo 2MB\'den küçük olmalıdır',
      location: 'Konum',
      contactInformation: 'İletişim Bilgileri',
      branchesWithCount: 'Şubeler ({{count}})',
      statLabelBranches: 'Şubeler',
      statLabelEmployees: 'Çalışanlar',
      statLabelMenuItems: 'Menü Öğeleri',
      statLabelTotalTables: 'Toplam Masa',
      branchManagement: 'Şube Yönetimi',
      branchManagementDesc: 'Şubeleri ayrıntılı yapılandırmalarla ekleyin ve yönetin',
      menuManagementDesc: 'Kategoriler ve fiyatlarla menü öğeleri oluşturun ve düzenleyin',
      staffManagement: 'Personel Yönetimi',
      staffManagementDesc: 'Restoran personelini, rollerini ve izinlerini yönetin',
      analyticsReports: 'Analitik ve Raporlar',
      analyticsReportsDesc: 'Ayrıntılı analitikleri görüntüleyin ve iş raporları oluşturun',
      noBranchesAdded: 'Henüz şube eklenmedi.',
      addFirstBranch: 'İlk Şubeyi Ekle',
      manageAllBranches: 'Tüm Şubeleri Yönet',
      management: 'Yönetim',
      sectionBranches: 'Şubeler',
      aboutRestaurant: '{{name}} Hakkında',
      analyticsBackToRestaurants: 'Restoranlara Geri Dön',
      analyticsLoading: 'Restoran analitiği yükleniyor...',
      analyticsNoDataTitle: 'Analitik Veri Mevcut Değil',
      analyticsNoDataDescription:
        'Bu restoranda henüz analitik verisi yok. Şubeler veri üretmeye başladığında analitikler görünecektir.',
      analyticsTryAgain: 'Tekrar Dene',
      analyticsDashboardTitle: '{{name}} - Analitik Paneli',
      analyticsRefreshing: 'Yenileniyor...',
      analyticsRefresh: 'Yenile',
      analyticsTimeRange: 'Zaman Aralığı',
      analyticsLast7Days: 'Son 7 Gün',
      analyticsLast30Days: 'Son 30 Gün',
      analyticsLast90Days: 'Son 90 Gün',
      analyticsLastYear: 'Geçen Yıl',
      analyticsBranchFilter: 'Şube Filtresi',
      analyticsAllBranches: 'Tüm Şubeler',
      analyticsTotalBranchesCount: 'Toplam Şube: {{count}}',
      analyticsSummary: 'Analitik Özeti',
      analytics7Days: '7 Gün',
      analytics30Days: '30 Gün',
      analytics90Days: '90 Gün',
      analytics1Year: '1 Yıl',
      analyticsTimePeriod: 'Zaman Dilimi',
      analyticsDataPoints: 'Veri Noktaları',
      analyticsLastUpdated: 'Son Güncelleme',
      analyticsCombinedFromAllBranches: 'Tüm şubelerden birleştirildi',
      analyticsTotalOrders: 'Toplam Sipariş',
      analyticsAllBranchesCombined: 'Tüm şubeler birleştirildi',
      analyticsTotalExpenses: 'Toplam Gider',
      analyticsAllOperationalCosts: 'Tüm operasyonel maliyetler',
      analyticsNetProfit: 'Net Kar',
      analyticsRevenueMinusExpenses: 'Gelir eksi gider',
      analyticsConfiguration: 'Analitik Yapılandırması',
      analyticsBranchSelection: 'Şube Seçimi',
      analyticsAllBranchesCombinedLabel: 'Tüm Şubeler Birleşik',
      analyticsSalesTrendAllBranches: 'Satış Trendi (Tüm Şubeler)',
      analyticsNoSalesData: 'Satış verisi yok',
      analyticsDailyOrdersAllBranches: 'Günlük Siparişler (Tüm Şubeler)',
      analyticsNoOrdersData: 'Sipariş verisi yok',
      analyticsRevenueVsExpensesAllBranches: 'Gelir ve Gider (Tüm Şubeler)',
      analyticsNoFinancialData: 'Finansal veri yok',
      analyticsTopPerformingItems: 'En İyi Performans Gösteren Ürünler (Tüm Şubeler)',
      analyticsOrders: 'Sipariş',
      analyticsQty: 'Adet',
      analyticsBestPerformingBranch: 'En İyi Performanslı Şube',
      analyticsLoadingBestBranch: 'En iyi performanslı şube yükleniyor...',
      analyticsBestPerformingBranchBadge: '🏆 En İyi Performanslı Şube',
      analyticsAvgOrderValue: 'Ort. Sipariş Değeri',
      analyticsGrowthRate: 'Büyüme Oranı',
      analyticsBranchPerformanceRankings: 'Şube Performans Sıralaması',
      analyticsTopPerformer: '🏆 EN İYİ PERFORMANS',
      analyticsRank: 'Sıra {{rank}}',
      analyticsAvgOrder: 'Ort. Sipariş',
      analyticsGrowth: 'Büyüme',
      analyticsNoBestBranchData: 'Bu zaman aralığı için en iyi şube verisi bulunamadı.',
      analyticsDailyReports: 'Günlük Raporlar',
      analyticsDaysAvailableInDatabase: 'Veritabanında {{count}} Gün Mevcut',
      analyticsViewByRange: '{{range}} Analitik Görünümü',
      analyticsLoadingDates: 'Tarihler Yükleniyor...',
      analyticsFilterDates: 'Tarihleri Filtrele:',
      analyticsAllAvailableDates: 'Tüm Mevcut Tarihler',
      analyticsShowingTotalDates: 'Veritabanından toplam {{count}} tarih gösteriliyor',
      analyticsLoadingAllDates: 'Veritabanındaki tüm mevcut tarihler yükleniyor...',
      analyticsNoSalesDataShort: 'Satış Verisi Yok',
      analyticsGenerating: 'Oluşturuluyor...',
      analyticsGenerateReport: 'Rapor Oluştur',
      analyticsNoDatesAvailable: 'Tarih Bulunamadı',
      analyticsNoDatesDescription:
        'Veritabanında verisi olan tarih bulunamadı. Siparişler ve giderler kaydedildiğinde raporlar burada görünecektir.',
      analyticsNoDataToDownload: 'İndirilecek veri bulunamadı',
      analyticsPdfAutotableMissing:
        'PDF oluşturma başarısız: autoTable eklentisi yüklenmedi. Lütfen sayfayı yenileyip tekrar deneyin.',
      analyticsPdfTitle: 'RESTORAN GUNLUK FINANSAL RAPORU',
      analyticsGeneratedOn: 'Oluşturulma tarihi',
      analyticsRestaurantInformation: 'Restoran Bilgileri',
      analyticsRestaurantId: 'Restoran Kimliği',
      analyticsRestaurantName: 'Restoran Adı',
      analyticsReportType: 'Rapor Türü',
      analyticsDailyFinancialAnalysis: 'Günlük Finansal Analiz (Tüm Şubeler Birleşik)',
      analyticsFinancialSummaryAllBranches: 'Finansal Özet (Tüm Şubeler Birleşik)',
      analyticsMetric: 'Metrik',
      analyticsValue: 'Değer',
      analyticsDailyRevenue: 'Günlük Gelir',
      analyticsDailyExpenses: 'Günlük Gider',
      analyticsOrdersProcessed: 'İşlenen Siparişler',
      analyticsProfitMargin: 'Kar Marjı',
      analyticsAverageOrderValue: 'Ortalama Sipariş Değeri',
      analyticsBranchBreakdown: 'Şube Dağılımı',
      analyticsSales: 'Satış',
      analyticsExpenses: 'Gider',
      analyticsProfit: 'Kar',
      analyticsUnknownBranch: 'Bilinmeyen Şube',
      analyticsPdfFooter: 'Restoran Yönetim Sistemi - Günlük Finansal Rapor',
      analyticsPdfSuccess: 'Günlük PDF raporu başarıyla oluşturuldu!',
      analyticsPdfError: 'Günlük PDF raporu oluşturulurken hata: {{error}}. Lütfen tekrar deneyin.',
      analyticsNoBranchesFound: 'Şube bulunamadı',
      analyticsUnavailable: 'Analitik kullanılamıyor',
    },

    // Branch
    branch: {
      title: 'Şube',
      branches: 'Şubeler',
      branchName: 'Şube Adı',
      branchDescription: 'Şube Açıklaması',
      createBranch: 'Şube Oluştur',
      editBranch: 'Şube Düzenle',
      deleteBranch: 'Şube Sil',
      branchDetails: 'Şube Detayları',
      branchSettings: 'Şube Ayarları',
      branchAnalytics: 'Şube Analitiği',
      noBranches: 'Şube bulunamadı',
      addBranch: 'Şube Ekle',
      currency: 'Para Birimi',
      branchLogo: 'Şube Logosu',
      uploadLogo: 'Logo Yükle',
      replaceLogo: 'Logoyu Değiştir',
      logoDescription: 'QR menü şablonlarında kullanmak için bir logo yükleyin (ayarlanmamışsa restoran logosu kullanılır)',
      noLogoUploaded: 'Logo yüklenmedi. QR menü şablonlarında kullanmak için bir logo yükleyin (ayarlanmamışsa restoran logosu kullanılır).',
      searchBranchesPlaceholder: 'Şubeleri ad, adres veya şehre göre ara...',
      allBranches: 'Tüm Şubeler',
      activeOnly: 'Yalnızca Aktif',
      inactiveOnly: 'Yalnızca Pasif',
      tablesCount: '{{count}} Masa',
      menuItemsCount: '{{count}} Menü öğesi',
      branchLocationsCount: 'Şube Konumları ({{count}})',
      loadingBranches: 'Şubeler yükleniyor...',
      getStartedAddFirstBranch: '{{name}} için ilk şubenizi ekleyerek başlayın',
      noBranchesMatchFilter: 'Mevcut arama veya filtre kriterlerinize uyan şube yok',
      selectRestaurantToViewBranches: 'Şubelerini görüntülemek için üst gezinti çubuğundaki açılır menüden bir restoran seçin.',
      loadingRestaurantInformation: 'Restoran Bilgileri Yükleniyor...',
      selectBranch: 'Şube Seç',
      branchList: 'Şube Listesi',
      globalBranchList: 'Global Şube Listesi',
      assignedMenus: 'Atanmış Menüler',
      assignedTables: 'Atanmış Masalar',
      sectionManager: 'Bölüm Yöneticisi',
      offlineSettings: 'Çevrimdışı Ayarlar',
      offlineModeSettings: 'Çevrimdışı Mod Ayarları',
      branchLogo: 'Şube Logosu',
      uploadLogo: 'Logo Yükle',
      replaceLogo: 'Logoyu Değiştir',
      logoDescription: 'QR menü şablonlarında kullanmak için bir logo yükleyin (ayarlanmamışsa restoran logosu kullanılır)',
      noLogoUploaded: 'Logo yüklenmedi. QR menü şablonlarında kullanmak için bir logo yükleyin (ayarlanmamışsa restoran logosu kullanılır).',
      offlineAutoSaveSettings: 'Çevrimdışı Otomatik Kaydetme Ayarları',
      paymentFirstSettings: 'Önce Ödeme Ayarları',
      receiptScanningSettings: 'Fiş Tarama Ayarları',
    },

    // Sales Report
    salesReport: {
      title: 'Satış Raporu',
      summary: 'Satış Özeti',
      menuItems: 'Menü Öğeleri Satışları',
      totalSales: 'Toplam Satış',
      totalExpenses: 'Toplam Gider',
      netProfit: 'Net Kar',
      avgOrderValue: 'Ortalama Sipariş Değeri',
      orders: 'sipariş',
      margin: 'kar marjı',
      cash: 'Nakit',
      card: 'Kart',
      mobile: 'Mobil',
      qr: 'QR Kod',
      paymentMethods: 'Ödeme Yöntemleri Dağılımı',
      dailySalesTrend: 'Günlük Satış Trendi',
      dailySalesSubtitle: 'Seçilen dönemde {{count}} gün',
      avgDailySales: 'Günlük ort.',
      bestDay: 'En iyi gün',
      periodTrend: 'Dönem trendi',
      salesByHour: 'Saate Göre Satış',
      ordersByHour: 'Saat Başına Sipariş',
      peakHourSales: 'Yoğun Saat (Satış)',
      peakHourOrders: 'Yoğun Saat (Sipariş)',
      busiestTimes: 'En Yoğun Saatler',
      busiestTimesSalesHint: 'Seçilen dönemde gelire göre en yoğun saatler',
      busiestTimesOrdersHint: 'Seçilen dönemde sipariş sayısına göre en yoğun saatler',
      peakShare: 'Zirvenin %{{pct}}’i',
      salesTrend: 'Satış ve Öğe Trendi',
      topItems: 'En Çok Satan 10 Öğe',
      itemName: 'Öğe Adı',
      quantity: 'Miktar',
      percentage: 'Toplamın %',
      printThermal: 'Raporu yazdır (fiş yazıcısı)',
      printThermalHint: 'POS ile aynı adisyon yazıcısını kullanır',
      printTitle: 'SATIŞ RAPORU',
      printPeriod: 'Dönem',
      printedAt: 'Yazdırıldı',
      printSales: 'SATIŞLAR',
      printCardNote: 'Kart: mobil ve QR dahil',
      printTotalDiscount: 'Toplam indirim',
      printExpenses: 'GİDERLER',
      printOrders: 'SİPARİŞLER',
      printOrderCount: 'Sipariş sayısı',
      printTakeaways: 'Paket',
      printTableOrders: 'Masa siparişleri',
      printDelivery: 'Teslimat',
      printByCategory: 'KATEGORİYE GÖRE',
      printNoCategories: 'Kategori verisi yok',
      printDeleted: 'SİLİNEN SİPARİŞLER',
      printDeletedCount: 'Adet',
      printDeletedValue: 'Toplam tutar',
      printFooter: 'Rapor sonu',
    },

    // Menu
    menu: {
      title: 'Menü',
      menuItems: 'Menü Öğeleri',
      menuItem: 'Menü Öğesi',
      itemName: 'Öğe Adı',
      itemDescription: 'Şube menü öğeleri farklı fiyatlar ve açıklamalarla özelleştirilebilir. Restoran genelindeki menü öğelerini buradan oluşturun ve yönetin. Şubeler bu öğeleri özelleştirebilir.',
      itemPrice: 'Öğe Fiyatı',
      itemCategory: 'Öğe Kategorisi',
      itemImage: 'Öğe Resmi',
      createMenuItem: 'Menü Öğesi Oluştur',
      editMenuItem: 'Menü Öğesi Düzenle',
      deleteMenuItem: 'Menü Öğesi Sil',
      noMenuItems: 'Menü öğesi bulunamadı',
      addMenuItem: 'Menü Öğesi Ekle',
      categories: 'Kategoriler',
      categoryName: 'Kategori Adı',
      createCategory: 'Kategori Oluştur',
      editCategory: 'Kategori Düzenle',
      deleteCategory: 'Kategori Sil',
      importMenu: 'Restorandan Menü İçe Aktar',
      exportMenu: 'Menü Dışa Aktar',
      menuFilters: 'Menü Filtreleri',
      searchMenu: 'Menü Ara',
      noItemsMessage: 'Öğe bulunamadı',
      menuManagement: 'Menü Yönetimi',
      backToBranch: 'Şubeye Geri Dön',
      backToRestaurant: 'Restorana Geri Dön',
      noCategoriesAvailable: 'Kategori bulunamadı',
      loadingMenuItems: 'Menü öğeleri yükleniyor...',
      noMenuItemsFound: 'Aramanızla eşleşen menü öğesi bulunamadı.',
      noMenuItemsForBranch: 'Bu şube için menü öğesi bulunamadı.',
      noMenuItemsInCategory: 'Bu kategoride menü öğesi bulunamadı.',
      addMenu: 'Menü Ekle',
      createBranchItem: 'Şube Öğesi Oluştur',
      copyFromBranch: 'Şubeden Kopyala',
      captureMenu: 'Menüyü Yakala',
      dragDropTipsTitle: 'Sürükle ve bırak ipuçları:',
      dragDropTipsBody: 'menü öğesi kartlarını aşağıdaki Tezgah Öğeleri paneline sürükleyerek tezgah yazıcısına yönlendirin. Yinelenen kategorileri birleştirmek için yukarıdaki Kategorileri düzenle\'ye tıklayın.',
      clearFilters: 'Filtreleri temizle',
      filterByCategory: 'Kategoriye göre filtrele',
      editCategories: 'Kategorileri düzenle',
      doneEditing: 'Düzenlemeyi bitir',
      itemsCount: '{{count}} öğe',
      itemsCountSingle: '{{count}} öğe',
      itemsCountFiltered: '{{filtered}} / {{total}}',
      noItemsMatchingSearch: '"{{query}}" ile eşleşen menü öğesi bulunamadı',
      tryDifferentKeywords: 'Farklı anahtar kelimeler deneyin veya aramayı temizleyin',
      clearSearch: 'Aramayı Temizle',
      noItemsInBranch: 'Bu şubede menü öğesi bulunamadı',
      importToGetStarted: 'Başlamak için restoran menüsünden menü öğeleri içe aktarın',
      createFirstItem: 'Başlamak için ilk menü öğenizi oluşturun',
      searchPlaceholder: 'Menü öğelerini ad, açıklama veya kategoriye göre ara...',
      searchAriaLabel: 'Menü öğelerini ara',
      importing: 'İçe aktarılıyor...',
      loadingCategories: 'Kategoriler yükleniyor...',
      deals: 'Kampanyalar',
      exclusiveOffers: 'Özel Teklifler',
      copying: 'Kopyalanıyor...',
    },

    // Tables
    table: {
      title: 'Masalar',
      tables: 'Masalar',
      tableName: 'Masa Adı',
      tableNumber: 'Masa Numarası',
      tableCapacity: 'kişilik',
      tableStatus: 'Masa Durumu',
      createTable: 'Masa Oluştur',
      editTable: 'Masa Düzenle',
      deleteTable: 'Masa Sil',
      tableDetails: 'Masa Detayları',
      tableManagement: 'Gelişmiş Masa Yönetimi',
      tableFormation: 'Masa Düzeni',
      tableFormationDescription: 'Masa Düzeni\'ni kullanarak masaları bölümlere göre organize edin, masa düzenlerini yönetin ve oturma düzenlemelerini yapılandırın.',
      tableSetupConfig: 'Masa Kurulum Yapılandırması',
      noTables: 'Masa Bulunamadı',
      addTable: 'Masa Ekle',
      available: 'Müsait',
      occupied: 'Dolu',
      reserved: 'Rezerve',
      cleaning: 'Temizleniyor',
      goToFormation: 'Düzene Git',
      seats: 'Kişilik',
      searchTables: 'Masalarda ara...',
      allWithCount: 'Tümü ({{count}})',
      availableWithCount: 'Müsait ({{count}})',
      occupiedWithCount: 'Dolu ({{count}})',
      tableWithNumber: 'Masa {{number}}',
    },

    // POS
    pos: {
      messageOrder: 'Mesajla sipariş',
      messageOrderPlaceholder: '2 tavuk biryani\nkola x3\npeynirli naan\n1 ayran',
      messageOrderHint: 'Siparişi not gibi yazın — her satıra bir ürün veya virgülle ayırın. Adet ürün adının önünde veya arkasında olabilir; adet yazılmazsa 1 kabul edilir.',
      messageOrderParsing: 'Okunuyor…',
      messageOrderParse: 'Siparişi oku',
      messageOrderDone: 'Tamam',
      messageOrderSomeNotAdded: 'Bazı ürünler eklenemedi:',
      messageOrderAddToCart: 'Sepete ekle',
      messageOrderNotFound: 'menüde bulunamadı, elle ekleyin',
      messageOrderNothingFound: 'Siparişte ürün bulunamadı — lütfen notu kontrol edin.',
      messageOrderNothingMatched: 'Menüyle eşleşen ürün yok — geri dönüp notu düzenleyin.',
      title: 'POS Sistemi',
      pointOfSale: 'Satış Noktası',
      newOrder: 'Yeni Sipariş',
      currentOrder: 'Mevcut Sipariş',
      orderHistory: 'Sipariş Geçmişi',
      checkout: 'Ödeme',
      payment: 'Ödeme',
      cash: 'Nakit',
      card: 'Kart',
      other: 'Diğer',
      customerInfo: 'Müşteri Bilgisi',
      customerName: 'Misafir',
      customerPhone: 'Müşteri Telefonu',
      customerEmail: 'Müşteri E-postası',
      orderItems: 'Sipariş Öğeleri',
      orderSummary: 'Sipariş Özeti',
      orderTotal: 'Sipariş Toplamı',
      total: 'Toplam',
      applyDiscount: 'İndirim Uygula',
      discountAmount: 'İndirim Tutarı',
      discountPercentage: 'İndirim Yüzdesi',
      paymentMethod: 'Ödeme Yöntemi',
      paymentStatus: 'Ödeme Durumu',
      paid: 'Ödendi',
      unpaid: 'Ödenmedi',
      partial: 'Kısmi',
      orderStatus: 'Sipariş Durumu',
      pending: 'Beklemede',
      processing: 'İşleniyor',
      completed: 'Tamamlandı',
      cancelled: 'İptal Edildi',
      table: 'Masa',
      takeaway: 'Paket Servis',
      delivery: 'Teslimat',
      dineIn: 'Restoranda',
      selectTable: 'Masa Seç',
      switchTable: 'Masa Değiştir',
      addItem: 'Öğe Ekle',
      removeItem: 'Öğe Kaldır',
      updateQuantity: 'Miktarı Güncelle',
      printReceipt: 'Fiş Yazdır',
      emailReceipt: 'Fişi E-posta ile Gönder',
      kitchenDisplay: 'Mutfak Ekranı',
      customerDisplay: 'Müşteri Ekranı',
      expenses: 'Giderler',
      newOrders: 'Yeni Siparişler',
      notifications: 'Bildirimler',
      socketConnection: 'Socket Bağlantısı',
      connected: 'Bağlı',
      disconnected: 'Bağlantı Kesildi',
      syncDetails: 'Senkronizasyon Detayları',
      voiceRecognition: 'Ses Tanıma',
      listening: 'Dinleniyor...',
      speakNow: 'Şimdi konuşun...',
      touchKeyboard: 'Dokunmatik Klavye',
      dailyExpenseManager: 'Günlük Gider Yöneticisi',
      customerOrderSimulator: 'Müşteri Sipariş Simülatörü',
      menuActive: 'Menü POS işlemleri için kullanılabilir',
      menuActiveHint: 'Müşteriler sipariş verebilir',
      menuInactive: 'Menü Şu Anda Pasif',
      menuDeactivated: 'Menü devre dışı bırakıldı ve POS işlemleri için kullanılamıyor.',
      activateMenu: 'Menüyü Etkinleştir',
      selectBranchForVoice: 'Ses tanımayı kullanmak için önce bir şube seçin.',
      voiceNotAvailable: 'Ses tanıma kullanılamıyor.',
      modifyOrder: 'Siparişi Düzenle',
      pleaseClickModifyButton: 'Bu siparişe öğe eklemek için lütfen "Düzenle" butonuna tıklayın.',
      orders: 'Siparişler',
      items: 'Öğeler',
      active: 'Aktif',
      inactive: 'Pasif',
      searchMenu: 'Menü ara...',
      currentOrder: 'Mevcut Sipariş',
      noItemsInOrder: 'Siparişte Öğe Yok',
      noOrderYet: 'Henüz Sipariş Yok',
      selectTableToStart: 'Sipariş almaya başlamak için bir masa seçin',
      editCustomer: 'Müşteriyi Düzenle',
      payAndPlaceOrder: 'Öde ve Sipariş Ver',
      placeOrder: 'Sipariş Ver',
      printRecentBill: 'Son Fişi Yazdır',
      lastOrder: 'Son Sipariş',
      selectItemsFromMenu: 'Bu siparişe eklemek için menüden öğe seçin',
      clickMenuItemsToAdd: 'Siparişe eklemek için menü öğelerine tıklayın',
      startByAddingItems: 'Bu masa için sipariş oluşturmak için menüden öğe ekleyerek başlayın',
      browseMenu: 'Menüyü Görüntüle',
      goToMenuTab: 'Menü Sekmesine Git',
      item: 'Öğe',
      qty: 'Adet',
      subtotal: 'Ara Toplam',
      tax: 'Vergi',
      discount: 'İndirim',
      alerts: 'Uyarılar',
      receipt: 'FİŞ',
      kitchenOrder: 'MUTFAK SİPARİŞİ',
      kitchenNote: 'MUTFAK NOTU:',
      noOrderFound: 'Fiş yazdırmak için sipariş bulunamadı',
      noItems: 'Öğe yok',
      price: 'Fiyat',
      available: 'Müsait',
      occupied: 'Dolu',
      reserved: 'Rezerve',
      allStatus: 'Tüm Durumlar',
      searchTableNumber: 'Masa numarası ara...',
      noTablesFound: 'Masa bulunamadı',
      noTablesFoundMessage: 'Filtrelerinizi ayarlamayı deneyin veya şubenize daha fazla masa ekleyin',
      allTablesSequential: 'Tüm Masalar (Sıralı)',
      tables: 'Masalar',
      menu: 'Menü',
      myOrders: 'Siparişlerim',
      kds: 'KDS',
      settings: 'Ayarlar',
      selectBranch: 'Şube Seç',
      newTakeaway: 'Yeni Paket Servis',
      newDelivery: 'Yeni Teslimat',
      draft: 'Taslak',
      preparing: 'Hazırlanıyor',
      ready: 'Hazır',
      pickedUp: 'Alındı',
      dispatched: 'Gönderildi',
      outForDelivery: 'Teslimatta',
      delivered: 'Teslim Edildi',
      takeawayOrders: 'Paket Servis Siparişleri',
      deliveryOrders: 'Teslimat Siparişleri',
      searchOrders: 'İsim, telefon, sipariş numarası ile ara...',
      noMatchingOrders: 'Eşleşen aktif sipariş yok',
      noActiveOrders: 'Aktif sipariş yok',
      tryAdjustingFilters: 'Arama veya filtrelerinizi ayarlamayı deneyin',
      createFirstOrder: 'Başlamak için ilk {type} siparişinizi oluşturun',
      loadingOrders: 'Siparişler yükleniyor...',
      guest: 'Misafir',
      scheduled: 'Planlanmış',
      item: 'öğe',
      items: 'öğe',
      hasActiveOrders: 'aktif siparişleri var',
      activeOrders: 'Aktif Siparişler',
      useCartPanelToManage: 'Siparişleri yönetmek için sağdaki sepet panelini kullanın',
      noActiveOrdersFound: 'Aktif sipariş bulunamadı',
      paymentFirstTable: 'Önce Ödeme - Masa',
      checkoutTable: 'Ödeme - Masa',
      each: 'her biri',
      modified: 'Değiştirildi',
      note: 'Not',
      addDiscount: 'İndirim ekle',
      applySalesTax: 'KDV uygula (%10)',
      removeSalesTax: 'KDV kaldır',
      receiptOrderRef: 'Sipariş no:',
      receiptDate: 'Tarih:',
      receiptTime: 'Saat:',
      receiptItemsHeading: 'KALEMLER',
      receiptThankYou: 'Bizi tercih ettiğiniz için teşekkürler!',
      receiptItemsToPrepare: 'HAZIRLANACAK KALEMLER',
      receiptModificationTitle: 'Güncel',
      counterOrder: 'KASA SİPARİŞİ',
      receiptAdded: 'EKLENEN:',
      receiptRemoved: 'ÇIKARILAN:',
      receiptQtyChanged: 'MİKTAR DEĞİŞTİ:',
      receiptNotAvailable: 'Yok',
      receiptVenueFallback: 'RESTORAN',
      payAndSendToKitchen: 'Öde ve Mutfağa Gönder',
      payNow: 'Şimdi Öde',
      printReceiptFirst: 'Ödemeden önce lütfen fişi yazdırın',
      statusBilled: 'Faturalı',
      postPrintModified: 'Faturalandıktan sonra değiştirildi',
      postPrintPriorityStripe: 'Fiş sonrası değişiklik — tutarları kontrol edin',
      selectPaymentMethod: 'Ödeme Yöntemi Seç',
      mobilePay: 'Mobil Ödeme',
      qrCode: 'QR Kod',
      splitBill: 'Bölünmüş Ödeme',
      splitBillTitle: 'Bölünmüş Ödeme',
      splitCashAmount: 'Nakit Tutar',
      splitCardAmount: 'Kart Tutarı',
      splitRemaining: 'Kalan',
      splitConfirm: 'Bölünmüş Ödemeyi Onayla',
      splitBack: 'Geri',
      splitCashExceedsTotal: 'Nakit tutar toplamı geçemez',
      incomingOrders: 'Gelen Siparişler',
      noPendingOrders: 'Bekleyen sipariş yok',
      customer: 'Müşteri',
      assignToTable: 'Masaya Ata',
      pleaseSelectTable: 'Lütfen bu sipariş için bir masa seçin',
      rejectOrder: 'Siparişi Reddet',
      confirmOrder: 'Siparişi Onayla',
      editCustomerInformation: 'Müşteri Bilgilerini Düzenle',
      confirmed: 'Onaylandı',
      served: 'Servis Edildi',
      refresh: 'Yenile',
      kitchenDisplaySystem: 'Mutfak Görüntüleme Sistemi',
      totalOrdersLabel: 'Toplam Sipariş',
      servedOrdersCount: 'Servis Edilen ({{count}})',
      showActiveOrders: 'Aktif Siparişleri Göster',
      allActive: 'Tüm Aktifler',
      noOrdersInKitchen: 'Şu anda mutfakta sipariş yok. Yeni siparişler otomatik görünecektir.',
      noOrdersWithFilter: '"{{filter}}" durumunda sipariş yok. Filtreyi değiştirmeyi deneyin.',
      startPreparing: 'Hazırlamaya Başla',
      markReady: 'Hazır İşaretle',
      markServed: 'Servis Edildi İşaretle',
      takeawayGuest: 'Paket Servis Misafiri',
      orderNumberLabel: 'Sipariş Numarası',
      noOrdersToShow: 'Gösterilecek sipariş yok.',
      searchOrdersHistory: 'Sipariş, müşteri veya ürün ara...',
      menuItemHistory: 'Menü Öğesi Geçmişi',
      export: 'Dışa Aktar',
      history: 'Geçmiş',
      deletedWas: 'Silindi (önceki: {{status}})',
      modifiedAndCompleted: 'Düzenlendi ve Tamamlandı',
      viewCart: 'Sepeti Gör',
      kitchenReceipt: 'Mutfak Fişi',
      completeModification: 'Değişikliği Tamamla',
      processPayment: 'Ödemeyi İşle',
      noActiveSession: 'Aktif Oturum Yok',
      sessionRequiredMessage: 'Oturum Modu etkin. Yeni sipariş açmadan önce bir oturum başlatmanız gerekiyor.',
      sessionRequiredWaiterMessage: 'Oturum Modu etkin. Sipariş almadan önce lütfen şube yöneticinizden bir oturum başlatmasını isteyin.',
      dismiss: 'Kapat',
      startSession: 'Oturum Başlat',
      startingSession: 'Başlatılıyor…',
      endSession: 'Oturumu Bitir',
      endDay: 'Günü Kapat',
      dayClosed: 'Gün Kapalı',
      tableLayout: 'Masa Düzeni:',
      sequential: 'Sıralı',
      sectioned: 'Bölümlü',
      cannotEndBusinessDay: 'İş Günü Kapatılamıyor',
      endDayBlockedMessage: 'İş gününü kapatmadan önce lütfen tüm aktif siparişleri tamamlayın.',
      occupiedTables: 'Dolu Masalar',
      activeTakeawayOrders: 'Aktif Paket Servis / Teslimat Siparişleri',
      gotIt: 'Anladım',
      unpaidBadge: 'ÖDENMEDİ — teslimde tahsil edin',
      openOrdersWarningTitle: 'Açık Siparişler',
      openOrdersWarningMessage: 'Hâlâ açık siparişler var. Yine de devam edebilirsiniz — bu siparişler açık kalır ve bir sonraki iş gününde tamamlanabilir (örneğin daha sonra ödeme yapacak bir müşteri).',
      endSessionAnyway: 'Yine de Oturumu Bitir',
      endDayAnyway: 'Yine de Günü Kapat',
      counterOfflineModeTitle: 'Kasa çevrimdışı modda',
      counterOfflineModeMessage:
        'Bu cihazdan verilen siparişlerin mutfağa iletilmesi için kasa POS\'unun Çevrimiçi moda alınması gerekir. Kasadaki personelden POS\'ta Çevrimiçi modu açmasını isteyin.',
      counterNotConnectedTitle: 'Kasa bağlı değil',
      counterNotConnectedMessage:
        'Kasa masaüstü uygulaması bağlı değil. Kasa bilgisayarında Resto360 POS\'u açın, giriş yapın ve Çevrimiçi modda kalın.',
      counterPrintStationDisabledTitle: 'Mutfak yazdırma istasyonu kapalı',
      counterPrintStationDisabledMessage:
        'Kasada uzaktan mutfak yazdırması kapalı. Kasa cihazında POS ayarlarından Yazdırma istasyonunu etkinleştirin.',
      remotePrintBlockedTitle: 'Sipariş verilemiyor',
      remotePrintBlockedMessage: 'Kasa yazdırma istasyonu uzak siparişler için hazır değil.',
      floorThemeLight: 'Açık renk masa ve menü paneline geç',
      floorThemeDark: 'Koyu masa ve menü paneline geç',
      floorThemeAria: 'POS masa ve menü paneli görünümü',
    },

    // Customer Display
    customerDisplay: {
      title: 'Sipariş Durumu',
      subtitle: 'Paket servis sipariş durumunuzu gerçek zamanlı olarak takip edin',
      preparing: 'Hazırlanıyor',
      ready: 'Hazır',
      noOrders: 'Şu anda aktif paket servis siparişi yok',
      customerDetails: 'Müşteri Detayları',
      customerName: 'Müşteri Adı',
      enterCustomerName: 'Müşteri adını girin',
      customerNameRequired: 'Müşteri adı gereklidir',
      phoneRequired: 'Telefon numarası gereklidir',
      areaRequiredForDelivery: 'Teslimat için alan gereklidir',
      streetRequiredForDelivery: 'Teslimat için sokak adresi gereklidir',
      failedToUpdateCustomerInfo: 'Müşteri bilgileri güncellenemedi. Lütfen tekrar deneyin.',
      deliveryAddress: 'Teslimat Adresi',
      area: 'Alan',
      areaRequired: 'Alan gereklidir',
      streetAddress: 'Sokak Adresi',
      streetRequired: 'Sokak gereklidir',
      buildingHouse: 'Bina/Ev',
      floor: 'Kat',
      apartmentUnit: 'Daire/Ünite',
      landmark: 'Yer İşareti',
      city: 'Şehir',
      building: 'Bina',
      apartment: 'Daire',
      savedAddresses: 'Kayıtlı Adresler',
      addNewAddress: 'Yeni Adres Ekle',
      customerInfoOptionalForTakeaway: 'Paket servis siparişleri için müşteri bilgileri isteğe bağlıdır. Bu alanları atlayabilirsiniz.',
      proceedToMenu: 'Menüye Devam Et',
      failedToCreateOrder: 'Sipariş oluşturulamadı. Lütfen tekrar deneyin.',
      specialInstructions: 'Özel Talimatlar',
    },

    // Orders
    order: {
      title: 'Siparişler',
      orders: 'Siparişler',
      orderNumber: 'Sipariş Numarası',
      orderDate: 'Sipariş Tarihi',
      orderTime: 'Sipariş Saati',
      orderType: 'Sipariş Türü',
      orderStatus: 'Sipariş Durumu',
      orderTotal: 'Sipariş Toplamı',
      createOrder: 'Sipariş Oluştur',
      editOrder: 'Sipariş Düzenle',
      deleteOrder: 'Sipariş Sil',
      // Silme gerekçesi (sorumluluk) — personel nedenini belirtmeli.
      cannotMovePaidOrder: 'Bu sipariş ödendi ve kapatıldı — başka bir masaya taşınamaz.',
      deleteReasonTitle: 'Bu siparişi neden siliyorsunuz?',
      deleteReasonSubtitle: 'Gerekçe zorunludur. Sipariş ile birlikte kaydedilir ve Geçmiş sekmesinde görünür.',
      deleteReasonCustomerCancelled: 'Müşteri iptal etti',
      deleteReasonWrongOrder: 'Yanlış sipariş girildi',
      deleteReasonDuplicate: 'Mükerrer sipariş',
      deleteReasonTestOrder: 'Test siparişi',
      deleteReasonOther: 'Diğer',
      deleteReasonNoteLabel: 'Not',
      deleteReasonNotePlaceholder: 'Açıklama ekleyin ("Diğer" için zorunlu)',
      deleteReasonConfirm: 'Siparişi sil',
      deleteReasonCancel: 'Vazgeç',
      deletedReason: 'Silme gerekçesi',
      orderDetails: 'Sipariş Detayları',
      noOrders: 'Sipariş bulunamadı',
      addOrder: 'Sipariş Ekle',
      viewOrder: 'Siparişi Görüntüle',
      cancelOrder: 'Siparişi İptal Et',
      completeOrder: 'Siparişi Tamamla',
    },

    // Orders History (filter labels and buttons)
    orderHistory: {
      branch: 'Şube',
      selectBranch: 'Şube seçin',
      user: 'Kullanıcı',
      selectUser: 'Kullanıcı seçin',
      startDate: 'Başlangıç tarihi',
      endDate: 'Bitiş tarihi',
      search: 'Ara',
      filters: 'Filtreler',
      today: 'Bugün',
      last15Days: 'Son 15 gün',
      last30Days: 'Son 30 gün',
      last60Days: 'Son 60 gün',
      results: 'Sonuçlar',
      loading: 'Yükleniyor...',
      numberOfOrders: 'Sipariş sayısı:',
      noOrdersInRange: 'Bu aralıkta sipariş yok.',
      pleaseSelectBranchUserDate: 'Lütfen şube, kullanıcı ve tarih aralığı seçin.',
      failedToLoadOrders: 'Siparişler yüklenemedi.',
    },

    // QR Menu List page
    qrMenuList: {
      selectBranch: 'Şube Seçin',
      selectBranchPlaceholder: '— Şube Seçin —',
      noQrMenuFound: 'QR Menü Bulunamadı',
      createQrMenuToGetStarted: 'Başlamak için bu şube için bir QR menü oluşturun.',
      createQrMenu: 'QR Menü Oluştur',
      noRestaurantSelected: 'Restoran Seçilmedi',
      selectRestaurantFromHeader: 'QR menüleri görüntülemek ve yönetmek için üst menüden bir restoran seçin.',
      pleaseSelectRestaurant: 'Lütfen üst menüden bir restoran seçin',
      pleaseSelectBranch: 'Lütfen bir şube seçin',
      errorCreatingQrMenu: 'QR menü oluşturulurken hata oluştu',
      restaurant: 'Restoran',
      menuItemsCount: '{{count}} Menü Öğesi',
      edit: 'Düzenle',
      downloadQr: 'QR İndir',
      copy: 'Kopyala',
      copied: 'Kopyalandı!',
    },

    // Users/Staff
    user: {
      title: 'Kullanıcılar',
      users: 'Kullanıcılar',
      staff: 'Personel',
      userName: 'Kullanıcı Adı',
      userEmail: 'Kullanıcı E-postası',
      userRole: 'Kullanıcı Rolü',
      userPhone: 'Kullanıcı Telefonu',
      createUser: 'Kullanıcı Oluştur',
      editUser: 'Kullanıcı Düzenle',
      deleteUser: 'Kullanıcı Sil',
      userDetails: 'Kullanıcı Detayları',
      noUsers: 'Kullanıcı bulunamadı',
      addUser: 'Kullanıcı Ekle',
      searchByNameOrEmail: 'Ad veya e-posta ile ara',
      allRoles: 'Tüm roller',
      loadingUsers: 'Kullanıcılar yükleniyor...',
      noStaffFound: 'Personel bulunamadı',
      noUsersMatchFilters: 'Mevcut filtrelerinize uyan kullanıcı yok.',
      addFirstTeamMember: 'Başlamak için ilk ekip üyenizi ekleyin.',
      roles: {
        owner: 'Sahip',
        admin: 'Yönetici',
        branch_admin: 'Şube Yöneticisi',
        restaurant_manager: 'Restoran Müdürü',
        manager: 'Müdür',
        branch_manager: 'Şube Müdürü',
        waiter: 'Garson',
        chef: 'Şef',
        cashier: 'Kasiyer',
        accountant: 'Muhasebeci',
      },
    },

    // Expenses
    expense: {
      title: 'Başlık',
      expenses: 'Giderler',
      expenseCategory: 'Gider Kategorisi',
      expenseCategories: 'Gider Kategorileri',
      createExpense: 'Gider Oluştur',
      editExpense: 'Gider Düzenle',
      deleteExpense: 'Gider Sil',
      expenseDetails: 'Gider Detayları',
      noExpenses: 'Gider bulunamadı',
      addExpense: 'Gider Ekle',
      receiptScanner: 'Fiş Tarayıcı',
      scanReceipt: 'Fiş Tara',
      uploadReceipt: 'Fiş Yükle',
      receiptReview: 'Fiş İnceleme',
      categoryName: 'Kategori Adı',
      createCategory: 'Kategori Oluştur',
      editCategory: 'Kategori Düzenle',
      deleteCategory: 'Kategori Sil',
      // Keys used by the POS Expenses tab (POSExpensesView)
      titleRequired: 'Gider başlığı gerekli.',
      priceRequired: "0'dan büyük bir tutar girin.",
      offlineNotice: 'Çevrimdışısınız — giderler yalnızca çevrimiçiyken kaydedilebilir. Bağlanıp tekrar deneyin.',
      saved: 'Gider kaydedildi.',
      titlePlaceholder: 'örn. Sebze, Tüp gaz…',
      amount: 'Tutar',
      category: 'Kategori',
      categoryOther: 'Diğer',
      paymentMethod: 'Ödeme',
      bankTransfer: 'Banka havalesi',
      date: 'Tarih',
      notes: 'Notlar (isteğe bağlı)',
      notesPlaceholder: 'Tedarikçi, fatura no…',
      todayExpenses: 'Bugünün giderleri',
      noneToday: 'Bugün kayıtlı gider yok.',
      noRestaurant: 'Restoran bilgisi eksik — sorun devam ederse POS uygulamasını yeniden başlatın.',
    },

    // Deals
    deal: {
      title: 'Kampanyalar',
      deals: 'Kampanyalar',
      dealName: 'Kampanya Adı',
      dealDescription: 'Kampanya Açıklaması',
      dealPrice: 'Kampanya Fiyatı',
      createDeal: 'Kampanya Oluştur',
      editDeal: 'Kampanya Düzenle',
      deleteDeal: 'Kampanya Sil',
      dealDetails: 'Kampanya Detayları',
      noDeals: 'Kampanya bulunamadı',
      addDeal: 'Kampanya Ekle',
    },

    // Settings
    settings: {
      title: 'Ayarlar',
      general: 'Genel',
      appearance: 'Görünüm',
      language: 'Dil',
      theme: 'Tema',
      darkMode: 'Karanlık Mod',
      lightMode: 'Aydınlık Mod',
      switchToLightMode: 'Aydınlık Moda Geç',
      switchToDarkMode: 'Karanlık Moda Geç',
      gradientBackgrounds: 'Gradyan Arka Planlar',
      turnOnGradient: 'Gradyan Arka Planları Aç',
      turnOffGradient: 'Gradyan Arka Planları Kapat',
      colorThemes: 'Renk Temaları',
      colorThemesDescription: '20 güzel renk teması arasından seçin. Her tema butonlar, kartlar, gradyanlar ve tüm arayüz öğeleri için renkler içerir.',
      notifications: 'Bildirimler',
      privacy: 'Gizlilik',
      security: 'Güvenlik',
      account: 'Hesap',
    },

    // Errors & Messages
    messages: {
      somethingWentWrong: 'Bir şeyler yanlış gitti',
      tryAgain: 'Lütfen tekrar deneyin',
      operationSuccess: 'İşlem başarıyla tamamlandı',
      operationFailed: 'İşlem başarısız oldu',
      confirmDelete: 'Bu öğeyi silmek istediğinizden emin misiniz?',
      deleteSuccess: 'Öğe başarıyla silindi',
      deleteFailed: 'Öğe silinemedi',
      saveSuccess: 'Başarıyla kaydedildi',
      saveFailed: 'Kaydetme başarısız oldu',
      updateSuccess: 'Başarıyla güncellendi',
      updateFailed: 'Güncelleme başarısız oldu',
      createSuccess: 'Başarıyla oluşturuldu',
      createFailed: 'Oluşturma başarısız oldu',
      networkError: 'Ağ hatası. Lütfen bağlantınızı kontrol edin.',
      unauthorized: 'Bu işlemi gerçekleştirmek için yetkiniz yok',
      notFound: 'Sayfa bulunamadı',
      serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
    },

    // Expenses
    expense: {
      title: 'Gider Raporu',
      expenseReport: 'Gider Raporu',
      messageEntryTitle: 'Hızlı gider girişi',
      messageEntryHint: 'Gün boyunca giderleri buraya ekleyin (örn. "sebze 200"). Şubedeki herkes kimin ne eklediğini görür. Gün sonunda Gönder\'e basın — her satır otomatik kategorize edilir ve yazan kişinin adıyla kaydedilir.',
      messageEntryPlaceholder: 'sebze 200\ntavuk 1500\nAli maaş 3000',
      messageEntrySubmit: 'Günün giderlerini gönder',
      messageEntrySaving: 'Gönderiliyor…',
      messageEntryAdded: 'gider eklendi',
      messageEntryTodayList: 'Bugünün giderleri',
      messageEntryEmpty: 'Bugün henüz gider kaydedilmedi.',
      messageEntryLoadError: 'Giderler yüklenemedi — Yenile’ye dokunun.',
      messageEntryAddLine: 'Ekle',
      messageEntryLinePlaceholder: 'sebze 200, tavuk 300',
      messageEntryPendingList: 'Bugünün notu (henüz gönderilmedi)',
      messageEntryPendingEmpty: 'Henüz satır yok — ilk gideri yukarıdan ekleyin.',
      messageEntryUnparsed: 'Şu kişilerin satırları okunamadı:',
      messageEntryDeleteConfirm: 'Bu gider silinsin mi?',
      messageEntryTruncated: 'Giriş çok uzun — eklenmeyen satır:',
      messageEntryNeedsAmount: 'Her satırda ürün adı ve tutar birlikte olmalı (örn. "sebze 200") — eklenmedi:',
      expenses: 'Giderler',
      expense: 'Gider',
      addExpense: 'Gider Ekle',
      editExpense: 'Gider Düzenle',
      deleteExpense: 'Gider Sil',
      scanReceipt: 'Fiş Tara',
      receiptScanning: 'Fiş Tarama',
      expenseDetails: 'Gider Detayları',
      expenseTitle: 'Gider Başlığı',
      expenseAmount: 'Tutar',
      expenseDate: 'Tarih',
      expenseCategory: 'Kategori',
      expenseDescription: 'Açıklama',
      expenseNotes: 'Notlar',
      paymentMethod: 'Ödeme Yöntemi',
      paymentCash: 'Nakit',
      paymentCard: 'Kart',
      receiptNumber: 'Fiş Numarası',
      approvedBy: 'Onaylayan',
      status: 'Durum',
      pending: 'Beklemede',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
      filters: 'Filtreler',
      startDate: 'Başlangıç Tarihi',
      endDate: 'Bitiş Tarihi',
      category: 'Kategori',
      allCategories: 'Tüm Kategoriler',
      merchant: 'Satıcı',
      allMerchants: 'Tüm Satıcılar',
      itemName: 'Ürün Adı',
      itemNameSearch: 'Ürün Adı (Ara)',
      searchByItemName: 'Ürün adına göre ara...',
      loading: 'Yükleniyor...',
      loadingExpenseReport: 'Gider raporu yükleniyor...',
      exportCSV: 'CSV Dışa Aktar',
      totalAmount: 'Toplam Tutar',
      totalExpenses: 'Toplam Giderler',
      totalSalaries: 'Toplam Maaşlar',
      highestSpending: 'En yüksek harcama',
      averageAmount: 'Ortalama Tutar',
      expensesByCategory: 'Kategoriye Göre Giderler',
      expensesByItem: 'Ürüne Göre Giderler',
      expensesByMerchant: 'Satıcıya Göre Giderler',
      expensesByDate: 'Tarihe Göre Giderler',
      totalQuantity: 'Toplam Miktar',
      unit: 'Birim',
      vatRate: 'KDV Oranı',
      merchantName: 'Satıcı Adı',
      count: 'Adet',
      noExpensesFound: 'Seçilen tarih aralığı ve filtreler için gider bulunamadı',
      selectBranchRestaurant: 'Gider raporlarını görüntülemek için lütfen bir şube ve restoran seçin',
      selectBranchRestaurantBeforeAdding: 'Gider eklemeden önce lütfen POS ekranından bir şube ve restoran seçin',
      salary: 'Maaş',
      salaries: 'Maaşlar',
      salaryMonth: 'Maaş ayı',
      salaryMonthRequired: 'Lütfen maaş ayını seçin',
      loan: 'Borç',
      loans: 'Borçlar',
      borrowerName: 'Borçlu adı',
      borrowerNamePlaceholder: 'örn. Faizan',
      deleteDay: 'Günü sil',
      exportExcel: 'Excel Raporu',
      exportSalaryExcel: 'Maaş Excel',
      exportPersonalExcel: 'Kişisel Excel',
      noExpensesForDay: 'Bu gün için kayıtlı gider yok',
      xlsxDate: 'Tarih',
      xlsxCash: 'Nakit',
      xlsxCredit: 'Kredi',
      xlsxTotal: 'Toplam',
      xlsxExpense: 'Gider',
      xlsxCreditExpense: 'Kredi Gideri',
      xlsxNetTotal: 'Net Toplam',
      xlsxTotalRow: 'TOPLAM',
      xlsxSummarySheet: 'Özet',
      xlsxLedgerSheet: 'Defter',
      xlsxCategorySheet: 'Kategoriye Göre Giderler',
      xlsxSalarySheet: 'Maaşlar',
      xlsxPersonalSheet: 'Kişisel Çekimler',
      xlsxPersonalFundSection: 'KİŞİSEL FON ÇEKİMLERİ (GİDERLERE DAHİL DEĞİLDİR)',
      xlsxPersonalFundDate: 'Tarih',
      xlsxPersonalFundName: 'İsim',
      xlsxPersonalFundAmount: 'Tutar',
      xlsxPersonalFundMethod: 'Yöntem',
      xlsxPersonalNote: 'Not',
      xlsxPersonalByMethod: 'ÖDEME YÖNTEMİNE GÖRE TOPLAM',
      xlsxPersonalByPerson: 'KİŞİYE GÖRE TOPLAM',
      personalWithdrawal: 'Kişisel çekim',
      markAsPersonal: 'Bu bir ortağın kişisel çekimi, işletme gideri değil',
      markAsPersonalHint: 'Ayrı olarak kişisel fon çekimi olarak kaydedilir — giderlerde görünmez ve net kârı azaltmaz.',
      filterLast7Days: 'Son 7 gün',
      filterLast30Days: 'Son 30 gün',
      filterLast90Days: 'Son 90 gün',
      filterLast6Months: 'Son 6 ay',
      filterToday: 'Bugün',
      filterPickDate: 'Tarih seç',
      filterCustomRange: 'Özel aralık',
      handwrittenRulesTitle: 'El Yazısı Not Kuralları',
      handwrittenRule1: 'Notun en üstüne başlık olarak "Giderler" yazın.',
      handwrittenRule2: 'Her satıra bir gider yazın.',
      handwrittenRule3: 'Önce gider başlığını, sonra fiyatı yazın.',
      handwrittenRule4: 'Maaş ödemeleri için isimle birlikte "maaş" kelimesini yazın.',
      handwrittenRule5: 'Fiyatı olabildiğince açık yazın.',
      handwrittenRule6: 'Notun üst kısmına tarihi yazın (örn. 24/04/2026) — aksi halde bugünün tarihi kullanılır.',
      report: 'Rapor',
      search: 'Ara',
      searchPlaceholder: 'Başlık, satıcı, fiş, kalem ara…',
      searchHintTitle: 'Gider ara',
      searchHintSub: 'Başlık, açıklama, kategori, fişteki satıcı ve ürün adlarında arar (üstteki tarih aralığındaki kayıtlar).',
      searchNoResults: 'Aramanızla eşleşen gider yok',
      searchTryDifferent: 'Başka kelimeler deneyin veya üstteki tarih filtresini genişletin.',
      searchResultsMeta: 'Yüklenen giderlerde {{count}} eşleşme',
      receiptReview: 'Fiş İnceleme',
      reviewReceiptData: 'Fiş Verilerini İncele',
      receiptData: 'Fiş Verileri',
      merchantInfo: 'Satıcı Bilgileri',
      items: 'Ürünler',
      saveExpense: 'Gideri Kaydet',
      cancel: 'İptal',
      processingReceipt: 'Fiş işleniyor...',
      extractingData: 'Fişten veri çıkarılıyor...',
      receiptDateOnReceipt: 'Fiş tarihi',
      scannedDate: 'Taranma',
      expenseBookedDate: 'Kayıt tarihi',
      addExpenseHint: 'Bu işlemi kaydetmek için aşağıdaki bilgileri doldurun.',
      editExpenseHint: 'Aşağıdaki bilgileri güncelleyin ve kaydedin.',
      employeeName: 'Çalışan adı',
      employeeNamePlaceholder: 'ör. Ahmet Yılmaz — Şef',
      categoryTitlePlaceholder: 'Kategori başlığını girin',
      expenseTitlePlaceholder: 'ör. Sebze teslimatı, Temizlik malzemeleri',
      amountAndDate: 'Tutar ve tarih',
      salaryAmount: 'Maaş tutarı',
      quickAdd: 'Hızlı ekle',
      recurring: 'Tekrarlayan',
      makeRecurring: 'Bu gideri otomatik olarak tekrarla',
      frequency: 'Sıklık',
      daily: 'Günlük',
      weekly: 'Haftalık',
      monthly: 'Aylık',
      dayOfMonth: 'Ayın günü',
      dayOfWeek: 'Haftanın günü',
      mode: 'Vadesi geldiğinde',
      autoPost: 'Otomatik ekle',
      askConfirm: 'Onayımı iste',
      draftsPending: 'Onayınızı bekleyen tekrarlayan giderler',
      noRecurring: 'Henüz tekrarlayan gider yok',
      noRecurringSub: 'Gider eklerken "Otomatik tekrarla" seçeneğini işaretleyerek kira, faturalar veya sabit maaşlar tanımlayabilirsiniz.',
      nextRun: 'sonraki',
      paused: 'Duraklatıldı',
      pause: 'Duraklat',
      resume: 'Devam et',
      categoryLabels: {
        foodSupplies: 'Gıda Malzemeleri',
        labor: 'İş Gücü',
        utilities: 'Faturalar',
        rent: 'Kira',
        equipment: 'Ekipman',
        salary: 'Maaş',
        other: 'Diğer',
      },
      // Keys used by the POS Expenses tab (POSExpensesView). This is the
      // WINNING `expense:` block (duplicated above); add keys here or they get
      // clobbered by JS object-literal key precedence.
      titleRequired: 'Gider başlığı gerekli.',
      priceRequired: "0'dan büyük bir tutar girin.",
      offlineNotice: 'Çevrimdışısınız — giderler yalnızca çevrimiçiyken kaydedilebilir. Bağlanıp tekrar deneyin.',
      saved: 'Gider kaydedildi.',
      titlePlaceholder: 'örn. Sebze, Tüp gaz…',
      amount: 'Tutar',
      categoryOther: 'Diğer',
      bankTransfer: 'Banka havalesi',
      notes: 'Notlar (isteğe bağlı)',
      notesPlaceholder: 'Tedarikçi, fatura no…',
      todayExpenses: 'Bugünün giderleri',
      noneToday: 'Bugün kayıtlı gider yok.',
      noRestaurant: 'Restoran bilgisi eksik — sorun devam ederse POS uygulamasını yeniden başlatın.',
      printReport: 'Gider Raporunu Yazdır',
      printTitle: 'GİDER RAPORU',
      noneForDate: 'Bu tarih için gider yok',
    },

    landingPage: {
      heroEyebrow: '#1 Restoran Yönetim Yazılımı',
      heroTitlePrefix: 'Yönetin',
      heroRotatingVenues: 'Fine Dining|Restoran|Kafe|Food Truck|Pastane',
      heroTitleSuffix: 'operasyonlarını',
      heroBrandName: 'TheResto360 ile',
      badge: 'HEPSİ BİR ARADA RESTORAN PLATFORMU',
      heroSubtitle:
        'Restro 360; POS, masa, menü, personel, QR sipariş ve raporlamayı tek akışta birleştirir—ekibiniz araçlarda değil, misafirlerde daha çok zaman harcar.',
      getStarted: 'Başlayın',
      watchFilm: 'Filmi izle',
      altPlayIcon: 'Oynat simgesi',
      altDashboardPreview: 'Restoran yönetim paneli önizlemesi',
      cinematicTitle: "Restro 360'ı çalışırken görün",
      videoSectionEyebrow: 'Ürün turu',
      cinematicSubtitle:
        'Günlük işletme için siparişler, salon, menü ve raporların kısa bir turu.',
      featuresSectionEyebrow: 'Temel özelliklerimiz',
      ariaVideoIntro: 'Restro 360 ürün önizleme videosu',
      altVideoPlaceholder: 'Video arka plan yer tutucu',
      experiencePill: "Restro 360'ı önizleyin",
      posShowcaseAria: 'Satış noktası tanıtımı',
      posShowcaseEyebrow: 'Satış noktası',
      posShowcaseTitle: 'Yoğun salonlar için tasarlanmış POS',
      posShowcaseSubtitle:
        'Saniyeler içinde sipariş alın, hesap bölün ve vardiyayı kapatın — Restro 360 POS\'u yakından görün.',
      posShowcaseDesktopLabel: 'Masaüstü',
      posShowcaseMobileLabel: 'Mobil',
      altPosDemo1: 'Restro 360 POS sipariş ekranı',
      altPosDemo2: 'Restro 360 POS ödeme ekranı',
      altPosDemoMobile: 'Restro 360 POS - mobil telefon görünümü',
      qrMenuShowcaseAria: 'QR menü tanıtımı',
      qrMenuShowcaseEyebrow: 'QR menü',
      qrMenuShowcaseTitle: 'Taratın, gezinin, sipariş verin — uygulama gerekmez',
      qrMenuShowcaseSubtitle:
        'Misafirlerinize telefonlarından saniyeler içinde açabilecekleri, fotoğraflı, kategorili ve anında sipariş verebilecekleri şık bir dijital menü sunun.',
      qrShowcaseAdminLabel: 'Yönetim',
      qrShowcaseGuestLabel: 'Misafir menüsü',
      altQrMenuDemo1: 'Restro 360 QR menü yönetim paneli - şablonlar ve QR kodu',
      altQrMenuDemo2: 'Restro 360 misafir QR menüsü - mobil görünüm',
      salesShowcaseAria: 'Satış raporları tanıtımı',
      salesShowcaseEyebrow: 'Satışlar ve raporlar',
      salesShowcaseTitle: 'Her vardiyada rakamlarınızı bilin',
      salesShowcaseSubtitle:
        'Geliri, en çok satan ürünleri ve eğilimleri gerçek zamanlı takip edin — daha hızlı ve daha akıllı kararlar almanıza yardımcı olan net satış raporları.',
      altSalesDemo1: 'Restro 360 satış panosu - gelir özeti',
      altSalesDemo2: 'Restro 360 satış panosu - ürün bazlı dağılım',
      altSalesDemo3: 'Restro 360 satış panosu - zaman içindeki eğilimler',
      tableShowcaseAria: 'Masa ve menü yönetimi tanıtımı',
      tableShowcaseEyebrow: 'Salon ve menü',
      tableShowcaseTitle: 'Salonunuzu kurun. Menünüzü oluşturun.',
      tableShowcaseSubtitle:
        'Kapalı ve açık alan masa düzenlerini görsel salon planında tasarlayın, her koltuğun canlı durumunu takip edin ve fotoğraflı, kategorili, fiyatlı menünüzü tek bir yönetim panelinden yönetin.',
      tableShowcaseTablesLabel: 'Masalar',
      tableShowcaseMenuLabel: 'Menü',
      altTableDemo: 'Restro 360 masa yönetimi salon planı - kapalı ve açık alan bölümleri',
      altMenuDemo: 'Restro 360 menü yönetimi ekranı - kategoriler ve ürünler',
      tableBullet1Title: 'Görsel salon planı',
      tableBullet1Text: 'Masaları bölümlere göre sürükle-bırak düzenle; tüm ekip salonu tek bakışta okusun.',
      tableBullet2Title: 'Canlı masa durumu',
      tableBullet2Text: 'Boş, dolu ve rezerve masaları anında görün — salon turu yok, tahmin yok.',
      tableBullet3Title: 'Eksiksiz menü kontrolü',
      tableBullet3Text: 'Kategorileri, yemek fotoğraflarını, fiyatları ve stok durumunu tek yerden yönetin; POS ve QR menüyle senkronize kalsın.',
      orderHistoryAria: 'Sipariş geçmişi tanıtımı',
      orderHistoryEyebrow: 'Sipariş geçmişi',
      orderHistoryTitle: 'Her sipariş kaydedilir ve görünür',
      orderHistorySubtitle:
        'Her sipariş, düzenleme, iptal ve ödeme zaman damgalı olarak kaydedilir ve işlemi yapan personelle ilişkilendirilir — işletme sahipleri için tam görünürlük, hırsızlığa sıfır şans.',
      orderHistoryTrustBadge: 'Her şey görülebilir — hırsızlığa şans yok',
      orderHistoryBullet1Title: 'Eksiksiz, zaman damgalı kayıt',
      orderHistoryBullet1Text: 'Her sipariş, düzenleme, iptal ve iade gerçekleştiği anda kaydedilir — hiçbir şey gözden kaçmaz.',
      orderHistoryBullet2Title: 'Personelle ilişkilendirilir',
      orderHistoryBullet2Text: 'Her işlem, onu gerçekleştiren kişiyle bağlantılıdır; sorumluluk her zaman netliğini korur.',
      orderHistoryBullet3Title: 'İşletme sahipleri için tam görünürlük',
      orderHistoryBullet3Text: 'Herhangi bir vardiyadaki herhangi bir siparişi arayın, filtreleyin ve inceleyin — işletmenizde tam şeffaflık.',
      altOrderHistory: 'Restro 360 sipariş geçmişi ekranı - her siparişin eksiksiz, zaman damgalı kaydı',
      masterpieceAria: 'Üstün özellikler bölümü',
      masterpieceTitleBefore: 'Başarılı bir ',
      masterpieceTitleAccent: 'restoran',
      masterpieceTitleAfter: ' için gereken her şey.',
      masterpieceSubtitle:
        'İlk siparişten kapanış raporuna kadar Restro 360, restoranınızın her adımını güçlendirir; ekibiniz karmaşıklıkla değil büyümeyle ilgilensin.',
      exploreFeatures: 'Tüm özellikleri keşfedin →',
      posTitle: 'Gerçek vardiyalar için POS',
      posDesc:
        'Salon içi, bar, paket ve teslimatı donanıma uygun akışlarla hızlıca işleyin—salon doluyken bile hız kesilmesin.',
      feature01: 'ÖZELLİK 01',
      altPosPreview: 'Yeni nesil POS önizlemesi',
      qrTitle: 'QR menüler ve misafir siparişi',
      qrDesc:
        'Dijital menüleri ve isteğe bağlı QR siparişi paylaşın; garsonların kullandığı adisyonlarla aynı hatta birleşir—çift menü bakımı yok.',
      realTimeStatus: 'Anlık durum',
      staffTitle: 'Güvenebileceğiniz personel',
      staffDesc:
        'Roller, yetkiler ve vardiya dostu araçlar; ikram, iptal veya düzeltme için doğru kişiler—sahipler için net iz.',
      analyticsTitle: 'Canlı analitik',
      analyticsDesc:
        'Satış, iş gücü ve menü performansını gece ilerlerken görün—yalnızca kapanıştan sonra değil.',
      reportsTitle: 'Defteri kapatan raporlar',
      reportsDesc:
        'Gün sonu paketleri, kategori dökümleri ve muhasebeciniz veya çoklu şube operasyonlarınız için dışa aktarıma uygun rakamlar.',
      trustedTitle: 'Yoğun salonları yöneten ekiplerin tercihi',
      marqueeAria: 'Güvenilen restoran markaları',
      statsAria: 'Büyüme özeti istatistikleri',
      statsHeading: 'Büyümeye tek bakışta',
      statsSubtitle:
        'Restro 360, servis sürelerini sıkılaştırmak, sipariş hatalarını azaltmak ve sahiplere tablolar olmadan görünürlük sunmak için tasarlandı.',
      kpiOneValue: 'Tek',
      kpiOneLabel: 'POS, salon ve menü için tek sistem',
      kpi247Value: '7/24',
      kpi247Label: 'Satış ve iş gücü görünürlüğü',
      altRevenue: 'Gelir',
      testimonialsAria: 'Müşteri yorumları',
      testimonialsHeading: 'Müşterilerimizden dinleyin',
      testimonialsSubtitle: 'Yoğun salonları yöneten ekiplerden hikayeler.',
      testimonialElenaQuote:
        "Beş şubemizi Restro 360'a taşımak\naldığımız en doğru operasyon kararıydı.\nYalnızca analitik sayesinde ilk çeyrekte\nisrafı çift haneli oranda düşürdük.",
      testimonialElenaAuthor: 'Elena Rodriguez',
      testimonialElenaRole: 'Sahip, Hearth & Vine',
      testimonialMarcusQuote:
        'Masa dönüşleri ve QR sipariş artık\nservisimizi gerçekten yansıtıyor.\nSalon ve mutfak aynı fişi görüyor—\nyoğun gecelerde daha az hata.',
      testimonialMarcusAuthor: 'Marcus Thorne',
      testimonialMarcusRole: 'Operasyon Direktörü, Urban Bowl',
      testimonialSarahQuote:
        'Personel yetkileri ve gün sonu raporları\nsonunda basit. Telefondan kapatıyorum ve\nrakamlar salondaki gerçekle\nuyuşuyor.',
      testimonialSarahAuthor: 'Sarah Chen',
      testimonialSarahRole: 'Müdür, Zen Kitchen',
      altAvatarElena: 'Elena Rodriguez avatar',
      altAvatarMarcus: 'Marcus Thorne avatar',
      altAvatarSarah: 'Sarah Chen avatar',
      leadGenAria: 'İletişim formu',
      leadGenTitle: 'Bize ulaşın',
      leadGenSubtitle:
        "Restoranınızdan bahsedin; Restro 360'ı işleyişinize göre POS, salon, menü ve raporlarla birlikte anlatalım.",
      leadGenBullet1: 'Menü ve donanım için onboarding planı',
      leadGenBullet2: 'Fiyatlandırma ve çoklu şube seçeneklerine net bakış',
      leadGenBullet3: 'Servis saatleri yoğunlaştığında sürekli destek',
      leadGenFooterNote: 'Restoranınızı 30 dakikada Restro 360’ta görün — hiçbir yükümlülük yok.',
      contactSubmitting: 'Gönderiliyor...',
      contactSubmitSuccess: 'Teşekkürler! Talebiniz iletildi — en kısa sürede sizinle iletişime geçeceğiz.',
      contactSubmitError: 'Talebiniz gönderilemedi. Lütfen tekrar deneyin veya doğrudan e-posta gönderin.',
      labelName: 'Ad Soyad',
      placeholderName: 'Ahmet Yılmaz',
      labelEmail: 'E-posta',
      placeholderEmail: 'ornek@restoran.com',
      labelCountry: 'Ülke',
      placeholderCountry: 'Türkiye',
      labelState: 'İl / İlçe',
      placeholderState: 'İstanbul, Kadıköy',
      labelRestaurant: 'Restoran adı',
      placeholderRestaurant: 'Grand Bistro',
      labelBusinessType: 'İşletme türü',
      businessFineDining: 'Fine dining',
      businessCasual: 'Gündelik restoran',
      businessFastCasual: 'Hızlı gündelik (fast casual)',
      labelStores: 'Şube sayısı',
      bookDemo: 'Demo randevusu al',
    },

    landingNav: {
      ariaTopNav: 'Üst gezinme',
      menu: 'Menü',
      logIn: 'Giriş yap',
      selectLanguage: 'Dil seçin',
      openMenu: 'Menüyü aç',
      closeMenu: 'Menüyü kapat',
      langEn: 'EN',
      langTr: 'TR',
      links: {
        features: 'Özellikler',
        pricing: 'Fiyatlandırma',
        testimonials: 'Referanslar',
        contact: 'Demo randevusu',
      },
    },

    landingFooter: {
      aria: 'Alt bilgi',
      tagline1: 'Restro 360 — Tüm işletmeyi',
      tagline2: 'tek komuta merkezinden yönetin.',
      tagline3: '',
      altGlobe: 'Dünya simgesi',
      altInstagram: 'Instagram',
      altEmail: 'E-posta simgesi',
      colProduct: 'Ürün',
      productOverview: 'Genel bakış',
      productPos: 'POS ve siparişler',
      productAiPhotos: 'AI yemek fotoğrafları',
      productQr: 'QR ve online sipariş',
      productExpenses: 'Gider yönetimi',
      productKds: 'Mutfak ekranı (KDS)',
      productMultiBranch: 'Çoklu şube yönetimi',
      productReports: 'Raporlar ve panel',
      productPricing: 'Fiyatlandırma',
      colCompany: 'Şirket',
      companyLogin: 'Giriş yap',
      companySignup: 'Kayıt ol',
      companyDemo: 'Demo randevusu',
      companyContact: 'Bize ulaşın',
      colLegal: 'Yasal',
      legalPrivacy: 'Gizlilik politikası',
      legalTerms: 'Hizmet şartları',
      copyright: '© 2025 Restro 360. Tüm hakları saklıdır.',
    },

    pricingPage: {
      faq: {
        sectionAria: 'Fiyatlandırma sık sorulan sorular',
        eyebrow: 'Yardım merkezi',
        title: 'Sık sorulan sorular',
        subtitle:
          'Fiyatlandırma, devreye alma ve Restro 360’ın ekibiniz için POS, salon, menü ve raporlamaya nasıl oturduğu.',
        bookDemoCta: 'Demo talep et →',
        items: {
          differentFromOthers: {
            question: 'Restro 360 diğer restoran sistemlerinden nasıl farklı?',
            answer:
              'Restro 360; POS, salon ve masalar, menü, QR sipariş, personel rolleri ve raporlamayı tek akışta birleştirir. Adisyonları, tükenenleri (86) ve gün sonu rakamlarını garsonların çalıştığı yerden yönetirsiniz—her iş için ayrı araçlarla uğraşmadan.',
          },
          deviceTableLimits: {
            question: 'Kaç cihaz ve masa kullanabiliriz?',
            answer:
              'Limitler seçtiğiniz pakete bağlıdır. Starter hafif QR menü kullanımı içindir; ücretli katmanlar tam POS ve daha fazla terminal, sunulan yerlerde sınırsız masa ekler. Zincir ve kurumsal paketler çok sayıda şube ve cihaza göre kurgulanır—uygun paket için bizimle konuşun.',
          },
          rushPerformance: {
            question: 'Yoğun saatlerde performans nasıl?',
            answer:
              'Ürün gerçek vardiyalar için tasarlandı: hızlı fiş girişi, salon ve mutfak arasında stabil senkron, sipariş hacmi sıçradığında da çalışan panolar. Donanım ve bağlantınız yine önemlidir; birlikte planlarız.',
          },
          setupTimeline: {
            question: 'Kurulum ne kadar sürer?',
            answer:
              'Süre menü büyüklüğüne, şube sayısına ve entegrasyonlara göre değişir. Çoğu ekip menü aktarımı, masa düzeni, roller ve eğitim ile başlar. İlk yapılandırmada ekibimiz yanınızdadır; ilk günü tek başınıza tahmin etmek zorunda kalmazsınız.',
          },
          dataSecurity: {
            question: 'Verilerimiz nasıl güvende tutuluyor?',
            answer:
              'Veriler yedekli ve erişim kontrollü güvenli bulut altyapısında durur. Personel yetkileri iptal, ikram veya hassas ayarları kimin değiştirebileceğini sınırlar; sahipler için net bir denetim izi kalır.',
          },
          paymentMethods: {
            question: 'Hangi ödeme yöntemleri destekleniyor?',
            answer:
              'Restro 360 restoranların beklediği akışları destekler—nakit, kart ve işlemcinizin izin verdiğinde entegre terminaller. Tam entegrasyonlar bölge ve sağlayıcıya göre değişir; bunu devreye alma sırasında netleştiririz.',
          },
          qrSameMenuAsPos: {
            question: 'QR menü ile içerideki POS aynı menüyü mü kullanır?',
            answer:
              'Evet—tek platformun amacı bu. Ürünleri, fiyatları, yan ürünleri ve tükenenleri tek yerde tutarsınız; QR okutan misafir ile POS’ta yazan garson aynı kataloğu görür; ayrı tablolar veya ikinci bir menü uygulaması ile çift güncelleme yapmazsınız.',
          },
          multiLocation: {
            question: 'Birden fazla şube veya küçük bir zincir yönetebilir miyiz?',
            answer:
              'Evet. Üst paketler daha fazla cihaz ve şube kapasitesi ekler; Zincir / Kurumsal merkezi menü, yetkiler ve mağazalar arası raporlama içindir. Her lokelde yerel kontrol gerektiği rolleri ve yayılımı birlikte tasarlarız.',
          },
          hardwareRequirements: {
            question: 'Hangi donanıma ihtiyacımız var?',
            answer:
              'Çoğu ekip POS için tablet veya terminal, nakit alıyorsanız mutfak yazıcıları ve para çekmecesi kullanır. Uyumlu modeller pazara göre değişir; devreye almada sürücüler, ödeme cihazları ve minimum gereksinimleri netleştirir, yanlış ekipman almamanızı sağlarız.',
          },
          inventoryIncluded: {
            question: 'Stok veya envanter takibi dahil mi?',
            answer:
              'Sayım ve envanter akışları büyüyen işletmeler için tasarlanmış paketlerde yer alır (ayrıntı için plan kartınıza bakın). Daha hafif katmanlar QR menü ve temel POS’a odaklanır; mutfak ve satın alma için pars ve sayım önemliyse doğru katmanı öneririz.',
          },
          postLaunchSupport: {
            question: 'Yayına çıktıktan sonra nasıl bir destek alırız?',
            answer:
              'Menü, salon ve roller için yönlendirmeli kurulum ve personeli eğitirken sorularınız için kanallar sunulur. Kurumsal müşterilere genelde adlandırılmış bir yayılım yolu verilir; hiçbir planda Cuma akşamı tek başınıza doküman aramak zorunda kalmamanız hedeflenir.',
          },
          menuImportMigration: {
            question: 'Mevcut menüyü içe aktarabilir veya başka bir POS’tan geçiş yapabilir miyiz?',
            answer:
              'Yapılandırılmış içe aktarmaları ve mümkün olduğunda tablolardan veya dışa aktarmalardan kategori, yan ürün ve vergi eşlemesini destekleriz. Karmaşık geçişler kısa bir keşif görüşmesi gerektirebilir; otomatikleştirebileceğimiz ile manuel temizlik gereken kısmı baştan söyleriz.',
          },
        },
      },
      plans: {
        header: {
          eyebrow: 'Pinner fiyatlandırma',
          title: 'Size uygun planı seçin',
          subtitle:
            'QR menüden çok şubeli yönetime kadar her ihtiyaç için esnek ve şeffaf paketler.',
        },
        billing: {
          threeMonthly: '3 aylık',
          sixMonth: '6 aylık',
          yearly: 'Yıllık',
        },
        period: {
          threeMonths: '/3 ay',
          sixMonths: '/6 ay',
          year: '/yıl',
          perBranchMonth: '/ şube / ay',
        },
        labels: {
          contactUs: 'Satış ekibiyle iletişime geç →',
          getStarted: 'Ücretsiz başla →',
          freeTrial: '15 gün ücretsiz',
          capacity: 'Kapasite',
          features: 'Öne çıkan özellikler',
        },
        badgeMostPopular: 'En popüler',
        tiers: {
          standard: {
            name: 'Standard',
            subtitle: 'Tam sistem · hafif fiş tarama',
            description: 'Yoğun bir şubeyi yönetmek için ihtiyacınız olan her şey.',
            capacity:
              'Tam sistemi ve hafif fiş taramasını isteyen restoranlar için ideal.',
            ctaLabel: 'Ücretsiz başla →',
            trialNote: 'Satın almadan önce denemek için 5 ücretsiz fiş taraması dahil.',
            features: [
              'Tam POS ve sipariş yönetimi',
              'Menü, masalar ve QR dijital menü',
              'Personel ve rol yönetimi',
              'Gider ve maaş takibi',
              'Tekrarlayan giderler ve hızlı ekleme',
              'Satış ve şube analitiği',
              'Ayda 20 AI fiş taraması',
            ],
          },
          pro: {
            name: 'Pro',
            subtitle: 'Fişlerle çalışan şubeler için.',
            description:
              'Standard\'daki her şey, artı tarama limiti endişesi olmadan.',
            capacity: 'Aylık limit olmadan sınırsız AI fiş taraması.',
            ctaLabel: 'Pro\'ya geç →',
            features: [
              'Standard\'daki her şey',
              'Sınırsız AI fiş taraması',
              'Her fişten otomatik kategorize edilen giderler',
              'Öncelikli işleme',
            ],
          },
          enterprise: {
            name: 'Zincir / kurumsal',
            subtitle: '5+ şubeli gruplar için tasarlandı.',
            description:
              'Çok şubeli operasyonlar için merkezi kontrol ve özel koşullar.',
            priceLabel: 'Görüşelim',
            capacity: 'Tüm şubelerde Pro\'daki her şey',
            ctaLabel: 'Satış ekibiyle iletişime geç →',
            features: [
              'Çok şubeli panel ve birleşik raporlama',
              'Hacim fiyatlandırması ve özel faturalama döngüsü',
              'Özel devreye alma ve öncelikli destek',
              'Özel özellik talepleri',
            ],
          },
        },
      },
      cta: {
        title: 'Restro 360 ile servise hazır mısınız?',
        subtitle:
          'Deneme başlatın veya canlı tur ayarlayın—planları şube sayınız, cihazlarınız ve POS, QR ve raporları nasıl kullandığınıza göre hizalarız.',
        button: 'Başlayın →',
        note: '✓ Uygun denemelerde kredi kartı gerekmez · ✓ Menü ve salon kurulumunda rehberlik',
      },
    },
  },

  ur: {
    // Common
    common: {
      loading: 'لوڈ ہو رہا ہے...',
      save: 'محفوظ کریں',
      cancel: 'منسوخ کریں',
      delete: 'حذف کریں',
      deleting: 'حذف ہو رہا ہے…',
      edit: 'ترمیم',
      add: 'شامل کریں',
      create: 'بنائیں',
      update: 'اپ ڈیٹ کریں',
      search: 'تلاش کریں...',
      close: 'بند کریں',
      back: 'واپس',
      next: 'اگلا',
      previous: 'پچھلا',
      submit: 'جمع کروائیں',
      confirm: 'تصدیق',
      yes: 'ہاں',
      no: 'نہیں',
      ok: 'ٹھیک ہے',
      apply: 'لاگو کریں',
      reset: 'ری سیٹ',
      clear: 'صاف کریں',
      select: 'منتخب کریں',
      all: 'تمام',
      none: 'کوئی نہیں',
      actions: 'اعمال',
      status: 'حالت',
      name: 'نام',
      description: 'تفصیل',
      price: 'قیمت',
      quantity: 'مقدار',
      total: 'کل',
      subtotal: 'ذیلی کل',
      tax: 'ٹیکس',
      discount: 'رعایت',
      amount: 'رقم',
      date: 'تاریخ',
      time: 'وقت',
      type: 'قسم',
      category: 'زمرہ',
      image: 'تصویر',
      settings: 'ترتیبات',
      profile: 'پروفائل',
      logout: 'سائن آؤٹ',
      signOut: 'سائن آؤٹ',
      myProfile: 'میری پروفائل',
      notifications: 'اطلاعات',
      noData: 'کوئی ڈیٹا دستیاب نہیں',
      error: 'خرابی',
      success: 'کامیابی',
      warning: 'انتباہ',
      info: 'معلومات',
      required: 'ضروری',
      optional: 'اختیاری',
      active: 'فعال',
      inactive: 'غیر فعال',
      enabled: 'فعال',
      disabled: 'غیر فعال',
      online: 'آن لائن',
      offline: 'آف لائن',
      today: 'آج',
      tomorrow: 'کل',
      yesterday: 'کل',
      thisWeek: 'اس ہفتے',
      minutesAgo: '{{count}} منٹ پہلے',
      locale: 'ur-PK',
    },

    // Expenses
    expense: {
      title: 'اخراجات کی رپورٹ',
      expenseReport: 'اخراجات کی رپورٹ',
      expenses: 'اخراجات',
      expense: 'خرچ',
      addExpense: 'خرچ شامل کریں',
      editExpense: 'خرچ میں ترمیم کریں',
      deleteExpense: 'خرچ حذف کریں',
      scanReceipt: 'رسید اسکین کریں',
      receiptScanning: 'رسید اسکیننگ',
      expenseDetails: 'خرچ کی تفصیلات',
      expenseTitle: 'خرچ کا عنوان',
      expenseAmount: 'رقم',
      expenseDate: 'تاریخ',
      expenseCategory: 'زمرہ',
      expenseDescription: 'تفصیل',
      expenseNotes: 'نوٹس',
      paymentMethod: 'ادائیگی کا طریقہ',
      paymentCash: 'نقد',
      paymentCard: 'کارڈ',
      receiptNumber: 'رسید نمبر',
      approvedBy: 'منظور کیا',
      status: 'حالت',
      pending: 'زیر التواء',
      approved: 'منظور شدہ',
      rejected: 'مسترد',
      filters: 'فلٹرز',
      startDate: 'شروع کی تاریخ',
      endDate: 'اختتام کی تاریخ',
      category: 'زمرہ',
      allCategories: 'تمام زمرے',
      merchant: 'تاجر',
      allMerchants: 'تمام تاجر',
      itemName: 'آئٹم کا نام',
      itemNameSearch: 'آئٹم کا نام (تلاش)',
      searchByItemName: 'آئٹم کے نام سے تلاش کریں...',
      loading: 'لوڈ ہو رہا ہے...',
      loadingExpenseReport: 'خرچ کی رپورٹ لوڈ ہو رہی ہے...',
      exportCSV: 'CSV برآمد کریں',
      totalAmount: 'کل رقم',
      totalExpenses: 'کل اخراجات',
      averageAmount: 'اوسط رقم',
      expensesByCategory: 'زمرے کے لحاظ سے اخراجات',
      expensesByItem: 'آئٹم کے لحاظ سے اخراجات',
      expensesByMerchant: 'تاجر کے لحاظ سے اخراجات',
      expensesByDate: 'تاریخ کے لحاظ سے اخراجات',
      totalQuantity: 'کل مقدار',
      unit: 'یونٹ',
      vatRate: 'VAT کی شرح',
      merchantName: 'تاجر کا نام',
      count: 'گنتی',
      noExpensesFound: 'منتخب کردہ تاریخ کی حد اور فلٹرز کے لیے کوئی خرچ نہیں ملا',
      selectBranchRestaurant: 'خرچ کی رپورٹیں دیکھنے کے لیے براہ کرم ایک برانچ اور ریسٹورانٹ منتخب کریں',
      selectBranchRestaurantBeforeAdding: 'خرچ شامل کرنے سے پہلے براہ کرم POS اسکرین سے ایک برانچ اور ریسٹورانٹ منتخب کریں',
      salary: 'تنخواہ',
      salaries: 'تنخواہیں',
      salaryMonth: 'تنخواہ کا مہینہ',
      salaryMonthRequired: 'براہ کرم تنخواہ کا مہینہ منتخب کریں',
      loan: 'قرض',
      loans: 'قرضے',
      borrowerName: 'قرض لینے والے کا نام',
      borrowerNamePlaceholder: 'مثلاً Faizan',
      deleteDay: 'دن حذف کریں',
      exportExcel: 'ایکسل رپورٹ',
      noExpensesForDay: 'اس دن کے لیے کوئی خرچہ ریکارڈ نہیں ہے',
      xlsxDate: 'تاریخ',
      xlsxCash: 'نقد',
      xlsxCredit: 'کریڈٹ',
      xlsxTotal: 'کل',
      xlsxExpense: 'خرچہ',
      xlsxCreditExpense: 'کریڈٹ خرچہ',
      xlsxNetTotal: 'خالص کل',
      xlsxTotalRow: 'کل',
      xlsxSummarySheet: 'خلاصہ',
      xlsxLedgerSheet: 'لیجر',
      xlsxCategorySheet: 'کیٹیگری کے لحاظ سے اخراجات',
      xlsxPersonalFundSection: 'ذاتی فنڈ نکلوائی (اخراجات میں شامل نہیں)',
      xlsxPersonalFundDate: 'تاریخ',
      xlsxPersonalFundName: 'نام',
      xlsxPersonalFundAmount: 'رقم',
      filterLast7Days: 'گزشتہ 7 دن',
      filterLast30Days: 'گزشتہ 30 دن',
      filterLast90Days: 'گزشتہ 90 دن',
      filterLast6Months: 'گزشتہ 6 مہینے',
      filterToday: 'آج',
      filterPickDate: 'تاریخ منتخب کریں',
      filterCustomRange: 'مخصوص رینج',
      handwrittenRulesTitle: 'ہاتھ سے لکھے نوٹ کے اصول',
      handwrittenRule1: 'نوٹ کے سب سے اوپر "اخراجات" عنوان لکھیں۔',
      handwrittenRule2: 'ہر لائن میں ایک خرچہ لکھیں۔',
      handwrittenRule3: 'پہلے خرچے کا عنوان لکھیں، پھر قیمت۔',
      handwrittenRule4: 'تنخواہ کی ادائیگی کے لیے نام کے ساتھ "تنخواہ" یا "salary" کا لفظ ضرور لکھیں۔',
      handwrittenRule5: 'قیمت ممکنہ حد تک واضح لکھیں۔',
      handwrittenRule6: 'نوٹ کے اوپر تاریخ لکھیں (مثلاً 24/04/2026) — ورنہ آج کی تاریخ استعمال ہوگی۔',
      report: 'رپورٹ',
      search: 'تلاش',
      searchPlaceholder: 'عنوان، تاجر، رسید، لائن اشیاء تلاش کریں…',
      searchHintTitle: 'خرچ تلاش کریں',
      searchHintSub: 'عنوان، تفصیل، زمرہ، رسید پر تاجر اور اشیاء کے ناموں سے میل کھاتا ہے (اوپر کی تاریخ کی حد)۔',
      searchNoResults: 'آپ کی تلاش سے کوئی خرچ میل نہیں کھاتا',
      searchTryDifferent: 'دوسرے الفاظ آزمائیں یا اوپر تاریخ فلٹر وسیع کریں۔',
      searchResultsMeta: 'لوڈ شدہ اخراجات میں {{count}} میل',
      receiptReview: 'رسید کا جائزہ',
      reviewReceiptData: 'رسید کے ڈیٹا کا جائزہ لیں',
      receiptData: 'رسید کا ڈیٹا',
      merchantInfo: 'تاجر کی معلومات',
      items: 'آئٹمز',
      saveExpense: 'خرچ محفوظ کریں',
      cancel: 'منسوخ کریں',
      processingReceipt: 'رسید پر کارروائی ہو رہی ہے...',
      extractingData: 'رسید سے ڈیٹا نکالا جا رہا ہے...',
      receiptDateOnReceipt: 'رسید کی تاریخ',
      scannedDate: 'اسکین',
      expenseBookedDate: 'بک شدہ',
      addExpenseHint: 'اس لین دین کو ریکارڈ کرنے کے لیے تفصیلات پُر کریں۔',
      editExpenseHint: 'نیچے تفصیلات اپ ڈیٹ کریں اور محفوظ کریں۔',
      employeeName: 'ملازم کا نام',
      employeeNamePlaceholder: 'مثال: احمد علی — ہیڈ شیف',
      categoryTitlePlaceholder: 'زمرے کا عنوان درج کریں',
      expenseTitlePlaceholder: 'مثال: سبزی کی ڈیلیوری، صفائی کا سامان',
      amountAndDate: 'رقم اور تاریخ',
      salaryAmount: 'تنخواہ کی رقم',
      quickAdd: 'فوری شامل کریں',
      recurring: 'بار بار',
      makeRecurring: 'اس خرچ کو خودکار طور پر دہرائیں',
      frequency: 'تعدد',
      daily: 'روزانہ',
      weekly: 'ہفتہ وار',
      monthly: 'ماہانہ',
      dayOfMonth: 'مہینے کا دن',
      dayOfWeek: 'ہفتے کا دن',
      mode: 'واجب الادا ہونے پر',
      autoPost: 'خودکار شامل کریں',
      askConfirm: 'میری تصدیق مانگیں',
      draftsPending: 'آپ کی تصدیق کا انتظار کرنے والے بار بار خرچ',
      noRecurring: 'ابھی تک کوئی بار بار خرچ نہیں',
      noRecurringSub: 'خرچ شامل کرتے وقت "خودکار دہرائیں" منتخب کر کے کرایہ، یوٹیلیٹیز یا مقررہ تنخواہیں سیٹ کریں۔',
      nextRun: 'اگلا',
      paused: 'روک دیا گیا',
      pause: 'روکیں',
      resume: 'جاری رکھیں',
    },
  },

  de: {
    // Common
    common: {
      loading: 'Wird geladen...',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleting: 'Wird gelöscht…',
      edit: 'Bearbeiten',
      add: 'Hinzufügen',
      create: 'Erstellen',
      update: 'Aktualisieren',
      search: 'Suchen...',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Zurück',
      submit: 'Absenden',
      confirm: 'Bestätigen',
      yes: 'Ja',
      no: 'Nein',
      ok: 'OK',
      apply: 'Anwenden',
      reset: 'Zurücksetzen',
      clear: 'Löschen',
      select: 'Auswählen',
      all: 'Alle',
      none: 'Keine',
      actions: 'Aktionen',
      status: 'Status',
      name: 'Name',
      description: 'Beschreibung',
      price: 'Preis',
      quantity: 'Menge',
      total: 'Gesamt',
      subtotal: 'Zwischensumme',
      tax: 'Steuer',
      discount: 'Rabatt',
      amount: 'Betrag',
      date: 'Datum',
      time: 'Zeit',
      type: 'Typ',
      category: 'Kategorie',
      image: 'Bild',
      settings: 'Einstellungen',
      profile: 'Profil',
      logout: 'Abmelden',
      signOut: 'Abmelden',
      myProfile: 'Mein Profil',
      notifications: 'Benachrichtigungen',
      noData: 'Keine Daten verfügbar',
      error: 'Fehler',
      success: 'Erfolg',
      warning: 'Warnung',
      info: 'Info',
      required: 'Erforderlich',
      optional: 'Optional',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      online: 'Online',
      offline: 'Offline',
      today: 'Heute',
      tomorrow: 'Morgen',
      yesterday: 'Gestern',
      thisWeek: 'Diese Woche',
      minutesAgo: 'vor {{count}} Minuten',
      locale: 'de-DE',
    },

    // Expenses
    expense: {
      title: 'Ausgabenbericht',
      expenseReport: 'Ausgabenbericht',
      expenses: 'Ausgaben',
      expense: 'Ausgabe',
      addExpense: 'Ausgabe hinzufügen',
      editExpense: 'Ausgabe bearbeiten',
      deleteExpense: 'Ausgabe löschen',
      scanReceipt: 'Beleg scannen',
      receiptScanning: 'Beleg-Scanning',
      expenseDetails: 'Ausgabendetails',
      expenseTitle: 'Ausgabentitel',
      expenseAmount: 'Betrag',
      expenseDate: 'Datum',
      expenseCategory: 'Kategorie',
      expenseDescription: 'Beschreibung',
      expenseNotes: 'Notizen',
      paymentMethod: 'Zahlungsmethode',
      paymentCash: 'Bar',
      paymentCard: 'Karte',
      receiptNumber: 'Belegnummer',
      approvedBy: 'Genehmigt von',
      status: 'Status',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      rejected: 'Abgelehnt',
      filters: 'Filter',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      category: 'Kategorie',
      allCategories: 'Alle Kategorien',
      merchant: 'Händler',
      allMerchants: 'Alle Händler',
      itemName: 'Artikelname',
      itemNameSearch: 'Artikelname (Suche)',
      searchByItemName: 'Nach Artikelname suchen...',
      loading: 'Wird geladen...',
      loadingExpenseReport: 'Ausgabenbericht wird geladen...',
      exportCSV: 'CSV exportieren',
      totalAmount: 'Gesamtbetrag',
      totalExpenses: 'Gesamtausgaben',
      averageAmount: 'Durchschnittsbetrag',
      expensesByCategory: 'Ausgaben nach Kategorie',
      expensesByItem: 'Ausgaben nach Artikel',
      expensesByMerchant: 'Ausgaben nach Händler',
      expensesByDate: 'Ausgaben nach Datum',
      totalQuantity: 'Gesamtmenge',
      unit: 'Einheit',
      vatRate: 'MwSt-Satz',
      merchantName: 'Händlername',
      count: 'Anzahl',
      noExpensesFound: 'Keine Ausgaben für den ausgewählten Datumsbereich und die Filter gefunden',
      selectBranchRestaurant: 'Bitte wählen Sie eine Filiale und ein Restaurant aus, um Ausgabenberichte anzuzeigen',
      selectBranchRestaurantBeforeAdding: 'Bitte wählen Sie eine Filiale und ein Restaurant vom POS-Bildschirm aus, bevor Sie Ausgaben hinzufügen',
      salary: 'Gehalt',
      salaries: 'Gehälter',
      salaryMonth: 'Gehaltsmonat',
      salaryMonthRequired: 'Bitte wählen Sie den Gehaltsmonat',
      loan: 'Darlehen',
      loans: 'Darlehen',
      borrowerName: 'Name des Kreditnehmers',
      borrowerNamePlaceholder: 'z.B. Faizan',
      deleteDay: 'Tag löschen',
      exportExcel: 'Excel-Bericht',
      noExpensesForDay: 'Für diesen Tag sind keine Ausgaben erfasst',
      xlsxDate: 'Datum',
      xlsxCash: 'Bar',
      xlsxCredit: 'Kredit',
      xlsxTotal: 'Gesamt',
      xlsxExpense: 'Ausgabe',
      xlsxCreditExpense: 'Kreditausgabe',
      xlsxNetTotal: 'Nettogesamt',
      xlsxTotalRow: 'GESAMT',
      xlsxSummarySheet: 'Zusammenfassung',
      xlsxLedgerSheet: 'Kassenbuch',
      xlsxCategorySheet: 'Ausgaben nach Kategorie',
      xlsxPersonalFundSection: 'PERSÖNLICHE ENTNAHMEN (NICHT IN AUSGABEN ENTHALTEN)',
      xlsxPersonalFundDate: 'Datum',
      xlsxPersonalFundName: 'Name',
      xlsxPersonalFundAmount: 'Betrag',
      filterLast7Days: 'Letzte 7 Tage',
      filterLast30Days: 'Letzte 30 Tage',
      filterLast90Days: 'Letzte 90 Tage',
      filterLast6Months: 'Letzte 6 Monate',
      filterToday: 'Heute',
      filterPickDate: 'Datum wählen',
      filterCustomRange: 'Benutzerdefinierter Zeitraum',
      handwrittenRulesTitle: 'Regeln für handschriftliche Notizen',
      handwrittenRule1: 'Schreiben Sie "Ausgaben" als Überschrift oben auf die Notiz.',
      handwrittenRule2: 'Eine Ausgabe pro Zeile.',
      handwrittenRule3: 'Schreiben Sie zuerst den Ausgabentitel, dann den Preis.',
      handwrittenRule4: 'Bei Gehaltszahlungen das Wort "Gehalt" zusammen mit dem Namen angeben.',
      handwrittenRule5: 'Schreiben Sie den Preis so deutlich wie möglich.',
      handwrittenRule6: 'Schreiben Sie das Datum oben auf die Notiz (z.B. 24/04/2026) — sonst wird das heutige Datum verwendet.',
      report: 'Bericht',
      search: 'Suche',
      searchPlaceholder: 'Titel, Händler, Beleg, Positionen suchen…',
      searchHintTitle: 'Ausgaben durchsuchen',
      searchHintSub: 'Sucht in Titel, Beschreibung, Kategorie, Beleg-Händler und Artikelnamen für den gewählten Datumsbereich.',
      searchNoResults: 'Keine Ausgaben entsprechen Ihrer Suche',
      searchTryDifferent: 'Andere Begriffe versuchen oder den Datumsfilter oben erweitern.',
      searchResultsMeta: '{{count}} Treffer in geladenen Ausgaben',
      receiptReview: 'Belegprüfung',
      reviewReceiptData: 'Belegdaten prüfen',
      receiptData: 'Belegdaten',
      merchantInfo: 'Händlerinformationen',
      items: 'Artikel',
      saveExpense: 'Ausgabe speichern',
      cancel: 'Abbrechen',
      processingReceipt: 'Beleg wird verarbeitet...',
      extractingData: 'Daten aus Beleg extrahieren...',
      receiptDateOnReceipt: 'Belegdatum',
      scannedDate: 'Erfasst am',
      expenseBookedDate: 'Gebucht am',
      addExpenseHint: 'Füllen Sie die Details aus, um diese Transaktion zu erfassen.',
      editExpenseHint: 'Aktualisieren Sie die Details unten und speichern Sie.',
      employeeName: 'Mitarbeitername',
      employeeNamePlaceholder: 'z. B. Max Mustermann — Küchenchef',
      categoryTitlePlaceholder: 'Kategorietitel eingeben',
      expenseTitlePlaceholder: 'z. B. Gemüselieferung, Reinigungsmittel',
      amountAndDate: 'Betrag & Datum',
      salaryAmount: 'Gehaltsbetrag',
      quickAdd: 'Schnell hinzufügen',
      recurring: 'Wiederkehrend',
      makeRecurring: 'Diese Ausgabe automatisch wiederholen',
      frequency: 'Häufigkeit',
      daily: 'Täglich',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      dayOfMonth: 'Tag des Monats',
      dayOfWeek: 'Wochentag',
      mode: 'Wenn fällig',
      autoPost: 'Automatisch hinzufügen',
      askConfirm: 'Um Bestätigung bitten',
      draftsPending: 'Wiederkehrende Ausgaben warten auf Ihre Bestätigung',
      noRecurring: 'Noch keine wiederkehrenden Ausgaben',
      noRecurringSub: 'Beim Hinzufügen einer Ausgabe aktivieren Sie „Automatisch wiederholen“ für Miete, Nebenkosten oder feste Gehälter.',
      nextRun: 'nächste',
      paused: 'Pausiert',
      pause: 'Pausieren',
      resume: 'Fortsetzen',
    },
  },
};

// ── Turkish backfill ───────────────────────────────────────────────────────────
// Native Turkish copy for landing/POS strings that were previously falling back
// to English. Applied as a non-destructive merge (won't overwrite existing keys).
(() => {
  const tr = translations.tr;
  if (!tr) return;
  const fill = (obj, values) => {
    Object.keys(values).forEach((k) => {
      if (obj[k] === undefined) obj[k] = values[k];
    });
  };

  tr.pos = tr.pos || {};
  fill(tr.pos, {
    proceedToMenu: 'Menüye Geç',
    specialInstructions: 'Özel İstekler',
    specialInstructionsPlaceholder: 'Sipariş için özel istekleriniz...',
    area: 'Bölge',
    streetAddress: 'Açık Adres',
    city: 'Şehir',
    building: 'Bina',
    floor: 'Kat',
    apartment: 'Daire',
    landmark: 'Adres Tarifi',
    label: 'Etiket',
    deliveryInfo: 'Teslimat Bilgileri',
  });

  tr.landingPage = tr.landingPage || {};
  fill(tr.landingPage, {
    heroTitleLine1: 'Tüm restoranınızı yönetin —',
    heroTitleLine2Prefix: 'tek bir',
    heroTitleLine2Suffix: 'komuta merkezinden',
    socialProofEyebrow: 'REFERANSLAR',
    trustedTagline: 'Yoğun salonlar için tasarlandı. Gerçek cuma akşamlarında kanıtlandı.',
    resultsEyebrow: 'SONUÇLAR',
    kpiZeroValue: 'Sıfır',
    kpiZeroLabel: 'tekrarlanan menü — bir kez güncelleyin, her yerde yayınlayın',
    contactEyebrow: 'İLETİŞİM',
    leadGenFooterNote: 'Restoranınızı 30 dakikada Restro 360’ta görün — hiçbir yükümlülük yok.',
    pricingSectionEyebrow: 'FİYATLANDIRMA',
    pricingSectionTitle: 'Restoranınızla birlikte büyüyen planlar',
    pricingSectionSubtitle: 'Tek şubeyle başlayın. Zincire ölçeklenin. Kullanmadığınız için değil, kullandığınız için ödeyin.',
  });

  tr.landingPage.featuresGrid = tr.landingPage.featuresGrid || {};
  const fg = tr.landingPage.featuresGrid;
  const setFeat = (key, title, desc) => {
    fg[key] = fg[key] || {};
    if (fg[key].title === undefined) fg[key].title = title;
    if (fg[key].desc === undefined) fg[key].desc = desc;
  };
  setFeat('pos', 'POS', 'Satışları her yerden takip edin');
  setFeat('qrMenu', 'QR Menü', 'Şık şablonlar, sıfır yeniden baskı');
  setFeat('aiPhotos', 'Yapay Zekâ Yemek Fotoğrafları', 'Tek yüklemeyle menüye hazır');
  setFeat('smartExpenses', 'Akıllı Giderler', 'Fişi çekin, veri girişini atlayın');
  setFeat('waiterOrdering', 'Garson Siparişi', 'Misafirler sipariş verir, kontrol ekipte');
  setFeat('ownerDashboard', 'Yönetici Paneli', 'İşletmeniz bir bakışta');
  setFeat('multiBranch', 'Çok Şubeli', 'Karmaşa olmadan büyüyün');
  setFeat('sessionMode', 'Vardiya Modu', 'Kasayı kimin yönettiğini bilin');
  setFeat('staffRoles', 'Personel Rolleri', 'Her çalışana özel giriş');
  setFeat('kds', 'KDS', 'Mutfak uyumlu ve zamanında');
})();

export default translations;

